import { X as X$1, Sun, Moon } from './chunk-VM6WN336.js';
import * as React12 from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown, Loader2, Check, X, Search, ChevronRight, Circle, ChevronUp, ChevronLeft, AlertTriangle, ChevronsLeft, ChevronsRight, SlidersHorizontal, Calendar as Calendar$1, UploadCloud, File, CheckCircle2, AlertCircle, ArrowLeft, PanelLeft, PanelLeftClose, Menu, ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { cva } from 'class-variance-authority';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { Slot } from '@radix-ui/react-slot';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { DayPicker } from 'react-day-picker';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { Command as Command$1 } from 'cmdk';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as ContextMenuPrimitive from '@radix-ui/react-context-menu';
import { Drawer as Drawer$1 } from 'vaul';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as LabelPrimitive from '@radix-ui/react-label';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as SelectPrimitive from '@radix-ui/react-select';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as SliderPrimitive from '@radix-ui/react-slider';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { BarChart as BarChart$1, CartesianGrid, XAxis, YAxis, Tooltip as Tooltip$1, Legend, Bar, PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { useReactTable, getPaginationRowModel, getFilteredRowModel, getSortedRowModel, getCoreRowModel, flexRender } from '@tanstack/react-table';
import { ErrorEnvelopeSchema, moneyToDecimal } from '@yk/shared-types';
import { enUS, ar } from 'date-fns/locale';
import { format, subDays, endOfMonth, startOfMonth, subMonths } from 'date-fns';
import { useDropzone } from 'react-dropzone';
import { FormProvider, useFormState } from 'react-hook-form';
import Decimal from 'decimal.js';
import { parsePhoneNumberFromString, getCountryCallingCode } from 'libphonenumber-js';
import { create } from 'zustand';
import { Toaster, toast } from 'sonner';

function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var Accordion = AccordionPrimitive.Root;
var AccordionItem = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AccordionPrimitive.Item,
  {
    ref,
    className: cn("border-b border-border", className),
    ...props
  }
));
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(AccordionPrimitive.Header, { className: "flex", children: /* @__PURE__ */ jsxs(
  AccordionPrimitive.Trigger,
  {
    ref,
    className: cn(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium text-fg transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(ChevronDown, { className: "size-4 shrink-0 text-muted transition-transform duration-200" })
    ]
  }
) }));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
var AccordionContent = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(
  AccordionPrimitive.Content,
  {
    ref,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...props,
    children: /* @__PURE__ */ jsx("div", { className: cn("pb-4 pt-0", className), children })
  }
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
var alertVariants = cva(
  "relative w-full rounded-lg border p-4 ps-11 text-start [&>svg]:absolute [&>svg]:start-4 [&>svg]:top-4 [&>svg]:size-5",
  {
    variants: {
      variant: {
        default: "border-border bg-surface text-fg [&>svg]:text-fg",
        info: "border-primary/30 bg-primary/10 text-fg [&>svg]:text-primary",
        success: "border-success/30 bg-success/10 text-fg [&>svg]:text-success",
        warn: "border-warn/40 bg-warn/10 text-fg [&>svg]:text-warn",
        danger: "border-danger/40 bg-danger/10 text-fg [&>svg]:text-danger"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
var Alert = React12.forwardRef(
  ({ className, variant, ...props }, ref) => /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      role: "alert",
      className: cn(alertVariants({ variant }), className),
      ...props
    }
  )
);
Alert.displayName = "Alert";
var AlertTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "h5",
  {
    ref,
    className: cn("mb-1 font-medium leading-none tracking-tight", className),
    ...props
  }
));
AlertTitle.displayName = "AlertTitle";
var AlertDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-sm [&_p]:leading-relaxed", className),
    ...props
  }
));
AlertDescription.displayName = "AlertDescription";
var buttonVariants = cva(
  // Filled/CTA buttons are pills (rounded-full) per the FixFlow design; the
  // `icon` size keeps a circular shape. `link` opts back out to square corners.
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-fg hover:bg-primary/90",
        secondary: "bg-muted-surface text-fg hover:bg-muted-surface/80",
        outline: "border border-input bg-surface text-fg hover:bg-muted-surface",
        ghost: "text-fg hover:bg-muted-surface",
        link: "rounded-none text-primary underline-offset-4 hover:underline",
        danger: "bg-danger text-danger-fg hover:bg-danger/90",
        // Soft destructive (light-red) — e.g. the "Deactivate" button.
        dangerSoft: "bg-danger/10 text-danger hover:bg-danger/20"
      },
      size: {
        sm: "h-9 px-3.5",
        default: "h-10 px-5 py-2",
        lg: "h-11 px-8",
        icon: "size-10"
      }
    },
    defaultVariants: { variant: "default", size: "default" }
  }
);
var Button = React12.forwardRef(
  ({
    className,
    variant,
    size,
    asChild = false,
    loading = false,
    disabled,
    children,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx(
      Comp,
      {
        ref,
        className: cn(buttonVariants({ variant, size }), className),
        disabled: asChild ? void 0 : disabled ?? loading,
        "aria-busy": loading || void 0,
        ...props,
        children: asChild ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
          loading ? /* @__PURE__ */ jsx(Loader2, { className: "size-4 animate-spin", "aria-hidden": true }) : null,
          children
        ] })
      }
    );
  }
);
Button.displayName = "Button";
var AlertDialog = AlertDialogPrimitive.Root;
var AlertDialogTrigger = AlertDialogPrimitive.Trigger;
var AlertDialogPortal = AlertDialogPrimitive.Portal;
var AlertDialogOverlay = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      "fixed inset-0 z-overlay bg-fg/40 backdrop-blur-sm",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName;
var AlertDialogContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxs(AlertDialogPortal, { children: [
  /* @__PURE__ */ jsx(AlertDialogOverlay, {}),
  /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Content,
    {
      ref,
      className: cn(
        "fixed start-1/2 top-1/2 z-modal grid w-full max-w-lg -translate-y-1/2 gap-4 rounded-lg border border-border bg-surface p-6 shadow-lg ltr:-translate-x-1/2 rtl:translate-x-1/2",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        className
      ),
      ...props
    }
  )
] }));
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName;
function AlertDialogHeader({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex flex-col gap-2 text-center sm:text-start", className),
      ...props
    }
  );
}
function AlertDialogFooter({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        className
      ),
      ...props
    }
  );
}
var AlertDialogTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Title,
  {
    ref,
    className: cn("text-lg font-semibold text-fg", className),
    ...props
  }
));
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName;
var AlertDialogDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Description,
  {
    ref,
    className: cn("text-sm text-muted", className),
    ...props
  }
));
AlertDialogDescription.displayName = AlertDialogPrimitive.Description.displayName;
var AlertDialogAction = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Action,
  {
    ref,
    className: cn(buttonVariants(), className),
    ...props
  }
));
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName;
var AlertDialogCancel = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogPrimitive.Cancel,
  {
    ref,
    className: cn(buttonVariants({ variant: "outline" }), className),
    ...props
  }
));
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName;
var Avatar = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AvatarPrimitive.Root,
  {
    ref,
    className: cn(
      "relative flex size-10 shrink-0 overflow-hidden rounded-full",
      className
    ),
    ...props
  }
));
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AvatarPrimitive.Image,
  {
    ref,
    className: cn("aspect-square size-full", className),
    ...props
  }
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AvatarPrimitive.Fallback,
  {
    ref,
    className: cn(
      "flex size-full items-center justify-center rounded-full bg-muted-surface text-sm font-medium text-muted",
      className
    ),
    ...props
  }
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
var badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-fg",
        secondary: "border-transparent bg-muted-surface text-fg",
        success: "border-transparent bg-success text-success-fg",
        warn: "border-transparent bg-warn text-warn-fg",
        danger: "border-transparent bg-danger text-danger-fg",
        info: "border-transparent bg-info text-info-fg",
        outline: "border-border text-fg",
        // Soft tints (light bg + colored text) — the FixFlow status/tag look.
        primarySoft: "border-transparent bg-primary/10 text-primary",
        successSoft: "border-transparent bg-success/10 text-success",
        warnSoft: "border-transparent bg-warn/10 text-warn",
        dangerSoft: "border-transparent bg-danger/10 text-danger",
        infoSoft: "border-transparent bg-info/10 text-info",
        neutralSoft: "border-transparent bg-muted/15 text-muted"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function Badge({ className, variant, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: cn(badgeVariants({ variant }), className), ...props });
}
function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    DayPicker,
    {
      showOutsideDays,
      className: cn("p-3", className),
      classNames: {
        months: "flex flex-col sm:flex-row gap-2",
        month: "flex flex-col gap-4",
        month_caption: "flex justify-center pt-1 relative items-center w-full",
        caption_label: "text-sm font-medium",
        nav: "flex items-center gap-1 absolute inset-x-1 top-0 justify-between",
        button_previous: cn(
          buttonVariants({ variant: "outline" }),
          "size-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        button_next: cn(
          buttonVariants({ variant: "outline" }),
          "size-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        month_grid: "w-full border-collapse space-y-1",
        weekdays: "flex",
        weekday: "text-muted rounded-md w-9 font-normal text-[0.8rem]",
        week: "flex w-full mt-2",
        day: cn(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-e-md",
          "first:[&:has([aria-selected])]:rounded-s-md last:[&:has([aria-selected])]:rounded-e-md"
        ),
        day_button: cn(
          buttonVariants({ variant: "ghost" }),
          "size-9 p-0 font-normal aria-selected:opacity-100"
        ),
        range_start: "day-range-start rounded-s-md",
        range_end: "day-range-end rounded-e-md",
        range_middle: "aria-selected:bg-accent aria-selected:text-accent-fg",
        selected: "bg-primary text-primary-fg hover:bg-primary hover:text-primary-fg focus:bg-primary focus:text-primary-fg",
        today: "bg-accent text-accent-fg",
        outside: "day-outside text-muted aria-selected:text-muted",
        disabled: "text-muted opacity-50",
        hidden: "invisible",
        ...classNames
      },
      components: {
        Chevron: ({
          orientation,
          className: chevronClassName,
          ...chevronProps
        }) => {
          const Icon2 = orientation === "left" ? ChevronLeft : ChevronRight;
          return /* @__PURE__ */ jsx(
            Icon2,
            {
              className: cn("size-4 rtl:rotate-180", chevronClassName),
              ...chevronProps
            }
          );
        }
      },
      ...props
    }
  );
}
Calendar.displayName = "Calendar";
var Card = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn(
      "rounded-lg border border-border bg-surface text-fg shadow-sm",
      className
    ),
    ...props
  }
));
Card.displayName = "Card";
var CardHeader = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("flex flex-col gap-1.5 p-6", className),
    ...props
  }
));
CardHeader.displayName = "CardHeader";
var CardTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn(
      "text-lg font-semibold leading-none tracking-tight",
      className
    ),
    ...props
  }
));
CardTitle.displayName = "CardTitle";
var CardDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("text-sm text-muted", className), ...props }));
CardDescription.displayName = "CardDescription";
var CardContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("p-6 pt-0", className), ...props }));
CardContent.displayName = "CardContent";
var CardFooter = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("flex items-center p-6 pt-0", className),
    ...props
  }
));
CardFooter.displayName = "CardFooter";
var Checkbox = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  CheckboxPrimitive.Root,
  {
    ref,
    className: cn(
      "peer size-4 shrink-0 rounded-sm border border-primary ring-offset-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-fg",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(
      CheckboxPrimitive.Indicator,
      {
        className: cn("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ jsx(Check, { className: "size-4" })
      }
    )
  }
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger2 = CollapsiblePrimitive.CollapsibleTrigger;
var CollapsibleContent2 = CollapsiblePrimitive.CollapsibleContent;
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogClose = DialogPrimitive.Close;
var DialogOverlay = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      "fixed inset-0 z-overlay bg-fg/40 backdrop-blur-sm",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React12.forwardRef(({ className, children, showClose = true, ...props }, ref) => /* @__PURE__ */ jsxs(DialogPortal, { children: [
  /* @__PURE__ */ jsx(DialogOverlay, {}),
  /* @__PURE__ */ jsxs(
    DialogPrimitive.Content,
    {
      ref,
      className: cn(
        "fixed start-1/2 top-1/2 z-modal grid w-full max-w-lg -translate-y-1/2 gap-4 rounded-lg border border-border bg-surface p-6 shadow-lg ltr:-translate-x-1/2 rtl:translate-x-1/2",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        className
      ),
      ...props,
      children: [
        children,
        showClose ? /* @__PURE__ */ jsxs(DialogPrimitive.Close, { className: "absolute end-4 top-4 rounded-sm opacity-70 ring-offset-bg transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ jsx(X, { className: "size-4" }),
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Close" })
        ] }) : null
      ]
    }
  )
] }));
DialogContent.displayName = DialogPrimitive.Content.displayName;
function DialogHeader({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex flex-col gap-1.5 text-center sm:text-start",
        className
      ),
      ...props
    }
  );
}
function DialogFooter({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        className
      ),
      ...props
    }
  );
}
var DialogTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Title,
  {
    ref,
    className: cn(
      "text-lg font-semibold leading-none tracking-tight text-fg",
      className
    ),
    ...props
  }
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Description,
  {
    ref,
    className: cn("text-sm text-muted", className),
    ...props
  }
));
DialogDescription.displayName = DialogPrimitive.Description.displayName;
var Command = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1,
  {
    ref,
    className: cn(
      "flex size-full flex-col overflow-hidden rounded-md bg-surface text-fg",
      className
    ),
    ...props
  }
));
Command.displayName = Command$1.displayName;
function CommandDialog({
  children,
  shouldFilter,
  ...props
}) {
  return /* @__PURE__ */ jsx(Dialog, { ...props, children: /* @__PURE__ */ jsx(DialogContent, { className: "overflow-hidden p-0", children: /* @__PURE__ */ jsx(
    Command,
    {
      ...shouldFilter !== void 0 ? { shouldFilter } : {},
      className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5",
      children
    }
  ) }) });
}
var CommandInput = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxs(
  "div",
  {
    className: "flex items-center border-b border-border px-3",
    "cmdk-input-wrapper": "",
    children: [
      /* @__PURE__ */ jsx(Search, { className: "me-2 size-4 shrink-0 opacity-50" }),
      /* @__PURE__ */ jsx(
        Command$1.Input,
        {
          ref,
          className: cn(
            "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted disabled:cursor-not-allowed disabled:opacity-50",
            className
          ),
          ...props
        }
      )
    ]
  }
));
CommandInput.displayName = Command$1.Input.displayName;
var CommandList = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.List,
  {
    ref,
    className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
    ...props
  }
));
CommandList.displayName = Command$1.List.displayName;
var CommandEmpty = React12.forwardRef((props, ref) => /* @__PURE__ */ jsx(
  Command$1.Empty,
  {
    ref,
    className: "py-6 text-center text-sm",
    ...props
  }
));
CommandEmpty.displayName = Command$1.Empty.displayName;
var CommandGroup = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Group,
  {
    ref,
    className: cn(
      "overflow-hidden p-1 text-fg [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted",
      className
    ),
    ...props
  }
));
CommandGroup.displayName = Command$1.Group.displayName;
var CommandSeparator = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Separator,
  {
    ref,
    className: cn("-mx-1 h-px bg-border", className),
    ...props
  }
));
CommandSeparator.displayName = Command$1.Separator.displayName;
var CommandItem = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Command$1.Item,
  {
    ref,
    className: cn(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-muted-surface data-[selected=true]:text-fg data-[disabled=true]:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0",
      className
    ),
    ...props
  }
));
CommandItem.displayName = Command$1.Item.displayName;
function CommandShortcut({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ms-auto text-xs tracking-widest text-muted", className),
      ...props
    }
  );
}
var ContextMenu = ContextMenuPrimitive.Root;
var ContextMenuTrigger = ContextMenuPrimitive.Trigger;
var ContextMenuGroup = ContextMenuPrimitive.Group;
var ContextMenuPortal = ContextMenuPrimitive.Portal;
var ContextMenuSub = ContextMenuPrimitive.Sub;
var ContextMenuRadioGroup = ContextMenuPrimitive.RadioGroup;
var menuContentBase = "z-popover min-w-32 overflow-hidden rounded-md border border-border bg-surface p-1 text-fg shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95";
var menuItemBase = "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-muted-surface data-[disabled]:pointer-events-none data-[disabled]:opacity-50";
var ContextMenuSubTrigger = React12.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.SubTrigger,
  {
    ref,
    className: cn(
      menuItemBase,
      "data-[state=open]:bg-muted-surface",
      inset && "ps-8",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(ChevronRight, { className: "ms-auto size-4 rtl:rotate-180" })
    ]
  }
));
ContextMenuSubTrigger.displayName = ContextMenuPrimitive.SubTrigger.displayName;
var ContextMenuSubContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.SubContent,
  {
    ref,
    className: cn(menuContentBase, className),
    ...props
  }
));
ContextMenuSubContent.displayName = ContextMenuPrimitive.SubContent.displayName;
var ContextMenuContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(ContextMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Content,
  {
    ref,
    className: cn(menuContentBase, className),
    ...props
  }
) }));
ContextMenuContent.displayName = ContextMenuPrimitive.Content.displayName;
var ContextMenuItem = React12.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Item,
  {
    ref,
    className: cn(menuItemBase, inset && "ps-8", className),
    ...props
  }
));
ContextMenuItem.displayName = ContextMenuPrimitive.Item.displayName;
var ContextMenuCheckboxItem = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(menuItemBase, "ps-8", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute start-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(Check, { className: "size-4" }) }) }),
      children
    ]
  }
));
ContextMenuCheckboxItem.displayName = ContextMenuPrimitive.CheckboxItem.displayName;
var ContextMenuRadioItem = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ContextMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(menuItemBase, "ps-8", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute start-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(ContextMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(Circle, { className: "size-2 fill-current" }) }) }),
      children
    ]
  }
));
ContextMenuRadioItem.displayName = ContextMenuPrimitive.RadioItem.displayName;
var ContextMenuLabel = React12.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Label,
  {
    ref,
    className: cn(
      "px-2 py-1.5 text-sm font-semibold text-fg",
      inset && "ps-8",
      className
    ),
    ...props
  }
));
ContextMenuLabel.displayName = ContextMenuPrimitive.Label.displayName;
var ContextMenuSeparator = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  ContextMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-border", className),
    ...props
  }
));
ContextMenuSeparator.displayName = ContextMenuPrimitive.Separator.displayName;
function ContextMenuShortcut({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ms-auto text-xs tracking-widest text-muted", className),
      ...props
    }
  );
}
function Drawer({
  shouldScaleBackground = true,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Drawer$1.Root,
    {
      shouldScaleBackground,
      ...props
    }
  );
}
Drawer.displayName = "Drawer";
var DrawerTrigger = Drawer$1.Trigger;
var DrawerPortal = Drawer$1.Portal;
var DrawerClose = Drawer$1.Close;
var DrawerOverlay = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Drawer$1.Overlay,
  {
    ref,
    className: cn("fixed inset-0 z-overlay bg-fg/40", className),
    ...props
  }
));
DrawerOverlay.displayName = "DrawerOverlay";
var DrawerContent = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(DrawerPortal, { children: [
  /* @__PURE__ */ jsx(DrawerOverlay, {}),
  /* @__PURE__ */ jsxs(
    Drawer$1.Content,
    {
      ref,
      className: cn(
        "fixed inset-x-0 bottom-0 z-modal mt-24 flex h-auto flex-col rounded-t-xl border border-border bg-surface",
        className
      ),
      ...props,
      children: [
        /* @__PURE__ */ jsx("div", { className: "mx-auto mt-4 h-2 w-24 rounded-full bg-muted-surface" }),
        children
      ]
    }
  )
] }));
DrawerContent.displayName = "DrawerContent";
function DrawerHeader({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("grid gap-1.5 p-4 text-center sm:text-start", className),
      ...props
    }
  );
}
function DrawerFooter({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("mt-auto flex flex-col gap-2 p-4", className),
      ...props
    }
  );
}
var DrawerTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Drawer$1.Title,
  {
    ref,
    className: cn(
      "text-lg font-semibold leading-none tracking-tight text-fg",
      className
    ),
    ...props
  }
));
DrawerTitle.displayName = "DrawerTitle";
var DrawerDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  Drawer$1.Description,
  {
    ref,
    className: cn("text-sm text-muted", className),
    ...props
  }
));
DrawerDescription.displayName = "DrawerDescription";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var menuContentBase2 = "z-popover min-w-32 overflow-hidden rounded-md border border-border bg-surface p-1 text-fg shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95";
var menuItemBase2 = "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-muted-surface data-[disabled]:pointer-events-none data-[disabled]:opacity-50";
var DropdownMenuSubTrigger = React12.forwardRef(({ className, inset, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  DropdownMenuPrimitive.SubTrigger,
  {
    ref,
    className: cn(
      menuItemBase2,
      "data-[state=open]:bg-muted-surface",
      inset && "ps-8",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(ChevronRight, { className: "ms-auto size-4 rtl:rotate-180" })
    ]
  }
));
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.SubContent,
  {
    ref,
    className: cn(menuContentBase2, className),
    ...props
  }
));
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React12.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(DropdownMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(menuContentBase2, className),
    ...props
  }
) }));
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React12.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Item,
  {
    ref,
    className: cn(menuItemBase2, inset && "ps-8", className),
    ...props
  }
));
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  DropdownMenuPrimitive.CheckboxItem,
  {
    ref,
    className: cn(menuItemBase2, "ps-8", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute start-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(Check, { className: "size-4" }) }) }),
      children
    ]
  }
));
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  DropdownMenuPrimitive.RadioItem,
  {
    ref,
    className: cn(menuItemBase2, "ps-8", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute start-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(Circle, { className: "size-2 fill-current" }) }) }),
      children
    ]
  }
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React12.forwardRef(({ className, inset, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Label,
  {
    ref,
    className: cn(
      "px-2 py-1.5 text-sm font-semibold",
      inset && "ps-8",
      className
    ),
    ...props
  }
));
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DropdownMenuPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-border", className),
    ...props
  }
));
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
function DropdownMenuShortcut({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("ms-auto text-xs tracking-widest text-muted", className),
      ...props
    }
  );
}
var HoverCard = HoverCardPrimitive.Root;
var HoverCardTrigger = HoverCardPrimitive.Trigger;
var HoverCardContent = React12.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(HoverCardPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  HoverCardPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn(
      "z-popover w-64 rounded-md border border-border bg-surface p-4 text-fg shadow-md outline-none",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      className
    ),
    ...props
  }
) }));
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;
var Input = React12.forwardRef(
  ({ className, type, ...props }, ref) => /* @__PURE__ */ jsx(
    "input",
    {
      type,
      ref,
      className: cn(
        "flex h-10 w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-fg",
        "placeholder:text-muted",
        "focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-fg",
        className
      ),
      ...props
    }
  )
);
Input.displayName = "Input";
var Label3 = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  LabelPrimitive.Root,
  {
    ref,
    className: cn(
      "text-sm font-medium leading-none text-fg",
      "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    ),
    ...props
  }
));
Label3.displayName = LabelPrimitive.Root.displayName;
var NativeSelect = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
  /* @__PURE__ */ jsx(
    "select",
    {
      ref,
      className: cn(
        "flex h-10 w-full appearance-none rounded-md border border-input bg-surface px-3 py-2 pe-9 text-sm text-fg",
        "focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props,
      children
    }
  ),
  /* @__PURE__ */ jsx(
    ChevronDown,
    {
      className: "pointer-events-none absolute end-3 top-1/2 size-4 -translate-y-1/2 text-muted",
      "aria-hidden": "true"
    }
  )
] }));
NativeSelect.displayName = "NativeSelect";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverAnchor = PopoverPrimitive.Anchor;
var PopoverClose = PopoverPrimitive.Close;
var PopoverContent = React12.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn(
      "z-popover w-72 rounded-md border border-border bg-surface p-4 text-fg shadow-md outline-none",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      className
    ),
    ...props
  }
) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
var Progress = React12.forwardRef(({ className, value, ...props }, ref) => /* @__PURE__ */ jsx(
  ProgressPrimitive.Root,
  {
    ref,
    className: cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-muted-surface",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(
      ProgressPrimitive.Indicator,
      {
        className: "size-full flex-1 bg-primary transition-transform",
        style: { transform: `translateX(${100 - (value ?? 0)}%)` }
      }
    )
  }
));
Progress.displayName = ProgressPrimitive.Root.displayName;
var RadioGroup3 = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  RadioGroupPrimitive.Root,
  {
    ref,
    className: cn("grid gap-2", className),
    ...props
  }
));
RadioGroup3.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  RadioGroupPrimitive.Item,
  {
    ref,
    className: cn(
      "aspect-square size-4 rounded-full border border-primary text-primary ring-offset-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Circle, { className: "size-2.5 fill-current text-current" }) })
  }
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
var ScrollBar = React12.forwardRef(({ className, orientation = "vertical", ...props }, ref) => /* @__PURE__ */ jsx(
  ScrollAreaPrimitive.ScrollAreaScrollbar,
  {
    ref,
    orientation,
    className: cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" && "h-full w-2.5 border-s border-s-transparent p-px",
      orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ScrollAreaPrimitive.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
  }
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
var ScrollArea = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  ScrollAreaPrimitive.Root,
  {
    ref,
    className: cn("relative overflow-hidden", className),
    ...props,
    children: [
      /* @__PURE__ */ jsx(ScrollAreaPrimitive.Viewport, { className: "size-full rounded-[inherit]", children }),
      /* @__PURE__ */ jsx(ScrollBar, {}),
      /* @__PURE__ */ jsx(ScrollAreaPrimitive.Corner, {})
    ]
  }
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
var Select = SelectPrimitive.Root;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  SelectPrimitive.Trigger,
  {
    ref,
    className: cn(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-bg px-3 py-2 text-sm text-fg ring-offset-bg placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      className
    ),
    ...props,
    children: [
      children,
      /* @__PURE__ */ jsx(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx(ChevronDown, { className: "size-4 opacity-50" }) })
    ]
  }
));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectScrollUpButton = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SelectPrimitive.ScrollUpButton,
  {
    ref,
    className: cn(
      "flex cursor-default items-center justify-center py-1",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ChevronUp, { className: "size-4" })
  }
));
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
var SelectScrollDownButton = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SelectPrimitive.ScrollDownButton,
  {
    ref,
    className: cn(
      "flex cursor-default items-center justify-center py-1",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(ChevronDown, { className: "size-4" })
  }
));
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
var SelectContent = React12.forwardRef(({ className, children, position = "popper", ...props }, ref) => /* @__PURE__ */ jsx(SelectPrimitive.Portal, { children: /* @__PURE__ */ jsxs(
  SelectPrimitive.Content,
  {
    ref,
    className: cn(
      "relative z-popover max-h-96 min-w-32 overflow-hidden rounded-md border border-border bg-surface text-fg shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=top]:-translate-y-1",
      className
    ),
    position,
    ...props,
    children: [
      /* @__PURE__ */ jsx(SelectScrollUpButton, {}),
      /* @__PURE__ */ jsx(
        SelectPrimitive.Viewport,
        {
          className: cn(
            "p-1",
            position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children
        }
      ),
      /* @__PURE__ */ jsx(SelectScrollDownButton, {})
    ]
  }
) }));
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SelectPrimitive.Label,
  {
    ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", className),
    ...props
  }
));
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = React12.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  SelectPrimitive.Item,
  {
    ref,
    className: cn(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pe-2 ps-8 text-sm outline-none focus:bg-muted-surface data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx("span", { className: "absolute start-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ jsx(SelectPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx(Check, { className: "size-4" }) }) }),
      /* @__PURE__ */ jsx(SelectPrimitive.ItemText, { children })
    ]
  }
));
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SelectPrimitive.Separator,
  {
    ref,
    className: cn("-mx-1 my-1 h-px bg-border", className),
    ...props
  }
));
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
var Separator4 = React12.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => /* @__PURE__ */ jsx(
    SeparatorPrimitive.Root,
    {
      ref,
      decorative,
      orientation,
      className: cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className
      ),
      ...props
    }
  )
);
Separator4.displayName = SeparatorPrimitive.Root.displayName;
var Sheet = DialogPrimitive.Root;
var SheetTrigger = DialogPrimitive.Trigger;
var SheetClose = DialogPrimitive.Close;
var SheetPortal = DialogPrimitive.Portal;
var SheetOverlay = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      "fixed inset-0 z-overlay bg-fg/40 backdrop-blur-sm",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
SheetOverlay.displayName = DialogPrimitive.Overlay.displayName;
var sheetVariants = cva(
  "fixed z-modal flex flex-col gap-4 bg-surface p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b border-border data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t border-border data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 start-0 h-full w-3/4 border-e border-border data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 end-0 h-full w-3/4 border-s border-border data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: { side: "right" }
  }
);
var SheetContent = React12.forwardRef(({ side = "right", className, children, ...props }, ref) => /* @__PURE__ */ jsxs(SheetPortal, { children: [
  /* @__PURE__ */ jsx(SheetOverlay, {}),
  /* @__PURE__ */ jsxs(
    DialogPrimitive.Content,
    {
      ref,
      className: cn(sheetVariants({ side }), className),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsxs(DialogPrimitive.Close, { className: "absolute end-4 top-4 rounded-sm opacity-70 ring-offset-bg transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", children: [
          /* @__PURE__ */ jsx(X, { className: "size-4" }),
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
SheetContent.displayName = DialogPrimitive.Content.displayName;
function SheetHeader({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex flex-col gap-1.5 text-center sm:text-start",
        className
      ),
      ...props
    }
  );
}
function SheetFooter({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "mt-auto flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        className
      ),
      ...props
    }
  );
}
var SheetTitle = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Title,
  {
    ref,
    className: cn("text-lg font-semibold text-fg", className),
    ...props
  }
));
SheetTitle.displayName = DialogPrimitive.Title.displayName;
var SheetDescription = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogPrimitive.Description,
  {
    ref,
    className: cn("text-sm text-muted", className),
    ...props
  }
));
SheetDescription.displayName = DialogPrimitive.Description.displayName;
function Skeleton({ className, ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("animate-pulse rounded-md bg-muted-surface", className),
      ...props
    }
  );
}
var Slider = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxs(
  SliderPrimitive.Root,
  {
    ref,
    className: cn(
      "relative flex w-full touch-none select-none items-center",
      className
    ),
    ...props,
    children: [
      /* @__PURE__ */ jsx(SliderPrimitive.Track, { className: "relative h-2 w-full grow overflow-hidden rounded-full bg-muted-surface", children: /* @__PURE__ */ jsx(SliderPrimitive.Range, { className: "absolute h-full bg-primary" }) }),
      /* @__PURE__ */ jsx(SliderPrimitive.Thumb, { className: "block size-5 rounded-full border-2 border-primary bg-bg ring-offset-bg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
Slider.displayName = SliderPrimitive.Root.displayName;
var Switch = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  SwitchPrimitive.Root,
  {
    ref,
    className: cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted-surface",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(
      SwitchPrimitive.Thumb,
      {
        className: cn(
          "pointer-events-none block size-5 rounded-full bg-bg shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0 ltr:data-[state=checked]:translate-x-5 rtl:data-[state=checked]:-translate-x-5"
        )
      }
    )
  }
));
Switch.displayName = SwitchPrimitive.Root.displayName;
var Tabs = TabsPrimitive.Root;
var TabsList = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.List,
  {
    ref,
    className: cn(
      // Use full-contrast fg (not text-muted) for inactive triggers: muted text
      // on the muted-surface fill fails WCAG AA (4.34:1 light / ~4:1 dark). The
      // active trigger stays distinguished by its surface fill + shadow.
      "inline-flex h-10 items-center justify-center rounded-md bg-muted-surface p-1 text-fg",
      className
    ),
    ...props
  }
));
TabsList.displayName = TabsPrimitive.List.displayName;
var TabsTrigger = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Trigger,
  {
    ref,
    className: cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-bg transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-surface data-[state=active]:text-fg data-[state=active]:shadow-sm",
      className
    ),
    ...props
  }
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = React12.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  TabsPrimitive.Content,
  {
    ref,
    className: cn(
      "mt-2 ring-offset-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    ),
    ...props
  }
));
TabsContent.displayName = TabsPrimitive.Content.displayName;
var Textarea = React12.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx(
    "textarea",
    {
      ref,
      className: cn(
        "flex min-h-20 w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-fg",
        "placeholder:text-muted",
        "focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props
    }
  )
);
Textarea.displayName = "Textarea";
var toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium ring-offset-bg transition-colors hover:bg-muted-surface hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-fg",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-muted-surface hover:text-fg"
      },
      size: {
        default: "h-10 min-w-10 px-3",
        sm: "h-9 min-w-9 px-2.5",
        lg: "h-11 min-w-11 px-5"
      }
    },
    defaultVariants: { variant: "default", size: "default" }
  }
);
var ToggleGroupContext = React12.createContext({
  size: "default",
  variant: "default"
});
var ToggleGroup = React12.forwardRef(({ className, variant, size, children, ...props }, ref) => /* @__PURE__ */ jsx(
  ToggleGroupPrimitive.Root,
  {
    ref,
    className: cn("flex items-center justify-center gap-1", className),
    ...props,
    children: /* @__PURE__ */ jsx(ToggleGroupContext.Provider, { value: { variant, size }, children })
  }
));
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
var ToggleGroupItem = React12.forwardRef(({ className, children, variant, size, ...props }, ref) => {
  const context = React12.useContext(ToggleGroupContext);
  return /* @__PURE__ */ jsx(
    ToggleGroupPrimitive.Item,
    {
      ref,
      className: cn(
        toggleVariants({
          variant: context.variant ?? variant,
          size: context.size ?? size
        }),
        className
      ),
      ...props,
      children
    }
  );
});
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React12.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  TooltipPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "z-tooltip overflow-hidden rounded-md bg-fg px-3 py-1.5 text-xs text-bg",
      "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=delayed-open]:zoom-in-95",
      className
    ),
    ...props
  }
) }));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
var PermissionContext = React12.createContext(() => false);
function PermissionProvider({
  can,
  children
}) {
  return /* @__PURE__ */ jsx(PermissionContext.Provider, { value: can, children });
}
function usePermission(code) {
  return React12.useContext(PermissionContext)(code);
}
function usePermissionChecker() {
  return React12.useContext(PermissionContext);
}
var DefaultShellLink = ({
  to,
  children,
  ...props
}) => /* @__PURE__ */ jsx("a", { href: to, ...props, children });
function isActivePath(currentPath, to) {
  if (!currentPath) return false;
  if (to === "/") return currentPath === "/";
  return currentPath === to || currentPath.startsWith(`${to}/`);
}
function filterByPermission(items, can) {
  return items.filter((item) => !item.permission || can(item.permission)).map(
    (item) => item.children ? { ...item, children: filterByPermission(item.children, can) } : item
  ).filter(
    (item) => !item.children || item.permission || item.children.length > 0
  );
}
var linkBase = "relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors";
function NavLeaf({
  item,
  currentPath,
  linkComponent: Link,
  collapsed,
  onNavigate,
  nested
}) {
  const Icon2 = item.icon;
  const active = isActivePath(currentPath, item.to);
  const inner = /* @__PURE__ */ jsxs(Fragment, { children: [
    Icon2 ? /* @__PURE__ */ jsx(Icon2, { className: "size-4 shrink-0", "aria-hidden": "true" }) : null,
    /* @__PURE__ */ jsx("span", { className: cn("truncate", collapsed && "sr-only"), children: item.label }),
    item.badge != null && !collapsed ? /* @__PURE__ */ jsx("span", { className: "ms-auto", children: item.badge }) : null
  ] });
  if (item.disabled) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: cn(
          linkBase,
          "cursor-not-allowed text-muted/60",
          nested && "ps-9"
        ),
        title: collapsed ? item.label : void 0,
        "data-testid": item.testId,
        "aria-disabled": "true",
        children: inner
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Link,
    {
      to: item.to,
      onClick: onNavigate,
      "data-testid": item.testId,
      "aria-current": active ? "page" : void 0,
      className: cn(
        linkBase,
        active ? "bg-primary/10 font-semibold text-primary before:absolute before:inset-y-1.5 before:start-0 before:w-1 before:rounded-full before:bg-primary" : "text-muted hover:bg-muted/10 hover:text-fg",
        nested && "ps-9"
      ),
      title: collapsed ? item.label : void 0,
      children: inner
    }
  );
}
function NavGroup({
  item,
  currentPath,
  linkComponent,
  collapsed,
  onNavigate
}) {
  const Icon2 = item.icon;
  const childActive = (item.children ?? []).some(
    (c) => isActivePath(currentPath, c.to)
  );
  const [open, setOpen] = React12.useState(childActive);
  React12.useEffect(() => {
    if (childActive) setOpen(true);
  }, [childActive]);
  return /* @__PURE__ */ jsxs(Collapsible, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsxs(
      CollapsibleTrigger2,
      {
        className: cn(
          linkBase,
          "w-full text-fg hover:bg-muted/10",
          childActive && "font-medium text-primary"
        ),
        title: collapsed ? item.label : void 0,
        children: [
          Icon2 ? /* @__PURE__ */ jsx(Icon2, { className: "size-4 shrink-0", "aria-hidden": "true" }) : null,
          /* @__PURE__ */ jsx("span", { className: cn("truncate", collapsed && "sr-only"), children: item.label }),
          !collapsed ? /* @__PURE__ */ jsx(
            ChevronDown,
            {
              className: cn(
                "ms-auto size-4 shrink-0 transition-transform",
                open && "rotate-180"
              ),
              "aria-hidden": "true"
            }
          ) : null
        ]
      }
    ),
    /* @__PURE__ */ jsx(CollapsibleContent2, { className: "mt-1 flex flex-col gap-1", children: (item.children ?? []).map((child) => /* @__PURE__ */ jsx(
      NavLeaf,
      {
        item: child,
        currentPath,
        linkComponent,
        collapsed,
        onNavigate,
        nested: true
      },
      child.to
    )) })
  ] });
}
function SideNav({
  items,
  currentPath,
  linkComponent = DefaultShellLink,
  collapsed,
  onNavigate,
  className
}) {
  const can = usePermissionChecker();
  const visible = React12.useMemo(
    () => filterByPermission(items, can),
    [items, can]
  );
  return /* @__PURE__ */ jsx("nav", { className: cn("flex flex-col gap-1", className), "aria-label": "Main", children: visible.map(
    (item) => item.children && item.children.length > 0 ? /* @__PURE__ */ jsx(
      NavGroup,
      {
        item,
        currentPath,
        linkComponent,
        collapsed,
        onNavigate
      },
      item.to
    ) : /* @__PURE__ */ jsx(
      NavLeaf,
      {
        item,
        currentPath,
        linkComponent,
        collapsed,
        onNavigate
      },
      item.to
    )
  ) });
}
function Breadcrumbs({
  items,
  linkComponent: Link = DefaultShellLink,
  className
}) {
  if (items.length < 2) return null;
  return /* @__PURE__ */ jsx("nav", { "aria-label": "Breadcrumb", className, children: /* @__PURE__ */ jsx("ol", { className: "flex flex-wrap items-center gap-1.5 text-sm text-muted", children: items.map((item, i) => {
    const isLast = i === items.length - 1;
    return /* @__PURE__ */ jsxs(
      "li",
      {
        className: "flex items-center gap-1.5",
        children: [
          i > 0 ? /* @__PURE__ */ jsx(
            ChevronRight,
            {
              className: "size-3.5 shrink-0 text-muted/60 rtl:rotate-180",
              "aria-hidden": "true"
            }
          ) : null,
          item.to && !isLast ? /* @__PURE__ */ jsx(
            Link,
            {
              to: item.to,
              className: "rounded-sm transition-colors hover:text-fg",
              children: item.label
            }
          ) : /* @__PURE__ */ jsx(
            "span",
            {
              className: cn(isLast && "font-medium text-fg"),
              "aria-current": isLast ? "page" : void 0,
              children: item.label
            }
          )
        ]
      },
      `${item.label}-${i}`
    );
  }) }) });
}
var ConfirmContext = React12.createContext(null);
function ConfirmProvider({ children }) {
  const [pending, setPending] = React12.useState(null);
  const confirm = React12.useCallback(
    (options) => new Promise((resolve) => {
      setPending({ ...options, resolve });
    }),
    []
  );
  const handleResolve = React12.useCallback((value) => {
    setPending((current) => {
      current?.resolve(value);
      return null;
    });
  }, []);
  return /* @__PURE__ */ jsxs(ConfirmContext.Provider, { value: confirm, children: [
    children,
    /* @__PURE__ */ jsx(
      AlertDialog,
      {
        open: pending !== null,
        onOpenChange: (open) => {
          if (!open) handleResolve(false);
        },
        children: pending ? /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
          /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
            /* @__PURE__ */ jsx(AlertDialogTitle, { children: pending.title }),
            pending.description ? /* @__PURE__ */ jsx(AlertDialogDescription, { children: pending.description }) : null
          ] }),
          /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
            /* @__PURE__ */ jsx(AlertDialogCancel, { onClick: () => handleResolve(false), children: pending.cancelLabel ?? "Cancel" }),
            /* @__PURE__ */ jsx(
              AlertDialogAction,
              {
                className: cn(
                  pending.destructive && buttonVariants({ variant: "danger" })
                ),
                onClick: () => handleResolve(true),
                children: pending.confirmLabel ?? "Confirm"
              }
            )
          ] })
        ] }) : null
      }
    )
  ] });
}
function useConfirm() {
  const ctx = React12.useContext(ConfirmContext);
  if (!ctx) {
    throw new Error(
      "useConfirm must be used within a ConfirmProvider (mounted by ThemeProvider)"
    );
  }
  return ctx;
}
function BulkActionBar({
  count,
  onClear,
  actions,
  selectedLabel,
  clearLabel = "Clear selection",
  className
}) {
  const confirm = useConfirm();
  const label = selectedLabel ?? `${count} selected`;
  React12.useEffect(() => {
    if (count <= 0) return;
    function onKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        onClear();
      }
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [count, onClear]);
  if (count <= 0) return null;
  async function handleAction(action) {
    if (action.variant === "destructive") {
      const ok = await confirm({
        title: action.confirmTitle ?? action.label,
        destructive: true,
        ...action.confirmDescription !== void 0 ? { description: action.confirmDescription } : {},
        ...action.confirmLabel !== void 0 ? { confirmLabel: action.confirmLabel } : {}
      });
      if (!ok) return;
    }
    action.onClick();
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "region",
      "aria-label": label,
      className: cn(
        "fixed inset-x-4 bottom-4 z-50 mx-auto flex w-fit max-w-screen-sm flex-wrap items-center justify-center gap-2 rounded-xl bg-primary px-3 py-2 text-primary-fg shadow-lg",
        className
      ),
      children: [
        /* @__PURE__ */ jsx("span", { className: "px-1 text-sm font-medium", "aria-live": "polite", children: label }),
        actions.map((action) => {
          const Icon2 = action.icon;
          const destructive = action.variant === "destructive";
          return /* @__PURE__ */ jsxs(
            Button,
            {
              type: "button",
              size: "sm",
              variant: destructive ? "danger" : "ghost",
              className: destructive ? void 0 : "text-primary-fg hover:bg-primary-fg/10 hover:text-primary-fg",
              onClick: () => void handleAction(action),
              children: [
                Icon2 ? /* @__PURE__ */ jsx(Icon2, { "aria-hidden": true }) : null,
                action.label
              ]
            },
            action.label
          );
        }),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            size: "icon",
            variant: "ghost",
            "aria-label": clearLabel,
            className: "size-8 text-primary-fg hover:bg-primary-fg/10 hover:text-primary-fg",
            onClick: onClear,
            children: /* @__PURE__ */ jsx(X$1, { "aria-hidden": true })
          }
        )
      ]
    }
  );
}
BulkActionBar.displayName = "BulkActionBar";

// src/theme/tokens.ts
var colorTokens = [
  "bg",
  "fg",
  "surface",
  "muted",
  "muted-surface",
  "primary",
  "primary-fg",
  "accent",
  "accent-fg",
  "success",
  "success-fg",
  "warn",
  "warn-fg",
  "danger",
  "danger-fg",
  "info",
  "info-fg",
  "border",
  "input",
  "ring"
];
var radiusTokens = ["sm", "md", "lg", "xl"];
var spaceTokens = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12"
];
var textTokens = [
  "xs",
  "sm",
  "base",
  "lg",
  "xl",
  "2xl",
  "3xl"
];
var shadowTokens = ["sm", "md", "lg"];
var zIndexTokens = [
  "dropdown",
  "sticky",
  "overlay",
  "modal",
  "popover",
  "toast",
  "tooltip"
];
function colorVar(token, alpha) {
  return alpha === void 0 ? `rgb(var(--color-${token}))` : `rgb(var(--color-${token}) / ${alpha})`;
}
function EmptyState({
  icon: Icon2,
  heading,
  body,
  action,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className
      ),
      children: [
        Icon2 ? /* @__PURE__ */ jsx(Icon2, { className: "size-10 text-muted", "aria-hidden": true }) : null,
        /* @__PURE__ */ jsx("h3", { className: "text-base font-semibold text-fg", children: heading }),
        body ? /* @__PURE__ */ jsx("p", { className: "max-w-sm text-sm text-muted", children: body }) : null,
        action ? /* @__PURE__ */ jsx("div", { className: "mt-2", children: action }) : null
      ]
    }
  );
}
var SERIES_TOKENS = [
  "primary",
  "info",
  "accent",
  "muted",
  "warn"
];
function seriesColor(token, index) {
  const fallback = SERIES_TOKENS[index % SERIES_TOKENS.length] ?? SERIES_TOKENS[0];
  return colorVar(token ?? fallback);
}
function chartOrientation(rtl) {
  return {
    xAxisReversed: rtl,
    yAxisOrientation: rtl ? "right" : "left",
    legendAlign: rtl ? "right" : "left",
    donutStartAngle: rtl ? -270 : 90,
    donutEndAngle: rtl ? 90 : -270
  };
}
function usePrefersReducedMotion() {
  const [reduced, setReduced] = React12.useState(
    () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  React12.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const onChange = (e) => setReduced(e.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return reduced;
}
function ChartFrame({
  loading,
  empty,
  emptyLabel = "No data to display",
  height = 280,
  className,
  ariaLabel,
  children
}) {
  if (loading) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "status",
        "aria-live": "polite",
        className: cn("w-full", className),
        style: { height },
        children: /* @__PURE__ */ jsx(Skeleton, { className: "size-full" })
      }
    );
  }
  if (empty) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn("flex w-full items-center justify-center", className),
        style: { height },
        children: /* @__PURE__ */ jsx(EmptyState, { heading: emptyLabel })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("w-full", className),
      style: { height },
      ...ariaLabel !== void 0 ? { role: "img", "aria-label": ariaLabel } : {},
      children: /* @__PURE__ */ jsx(ResponsiveContainer, { width: "100%", height: "100%", children })
    }
  );
}
function BarChart({
  data,
  categoryKey,
  series,
  stacked = false,
  loading,
  empty,
  emptyLabel,
  height,
  className,
  ariaLabel
}) {
  const reduced = usePrefersReducedMotion();
  const o = chartOrientation(false);
  const isEmpty = empty ?? (!loading && data.length === 0);
  const summary = ariaLabel ?? `Bar chart: ${series.map((s) => s.name).join(", ")} across ${data.length} ${categoryKey}s`;
  return /* @__PURE__ */ jsx(
    ChartFrame,
    {
      ...loading !== void 0 ? { loading } : {},
      empty: isEmpty,
      ...emptyLabel !== void 0 ? { emptyLabel } : {},
      ...height !== void 0 ? { height } : {},
      ...className !== void 0 ? { className } : {},
      ariaLabel: summary,
      children: /* @__PURE__ */ jsxs(
        BarChart$1,
        {
          data: data.map((d) => ({ ...d })),
          margin: { top: 8, right: 8, left: 8, bottom: 8 },
          children: [
            /* @__PURE__ */ jsx(
              CartesianGrid,
              {
                strokeDasharray: "3 3",
                stroke: colorVar("border"),
                vertical: false
              }
            ),
            /* @__PURE__ */ jsx(
              XAxis,
              {
                dataKey: categoryKey,
                reversed: o.xAxisReversed,
                tick: { fill: colorVar("muted"), fontSize: 12 },
                tickLine: false,
                axisLine: { stroke: colorVar("border") }
              }
            ),
            /* @__PURE__ */ jsx(
              YAxis,
              {
                orientation: o.yAxisOrientation,
                tick: { fill: colorVar("muted"), fontSize: 12 },
                tickLine: false,
                axisLine: false,
                allowDecimals: false
              }
            ),
            /* @__PURE__ */ jsx(
              Tooltip$1,
              {
                cursor: { fill: colorVar("muted", 0.12) },
                contentStyle: {
                  background: colorVar("surface"),
                  border: `1px solid ${colorVar("border")}`,
                  borderRadius: 8,
                  color: colorVar("fg"),
                  fontSize: 12,
                  direction: "ltr"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              Legend,
              {
                align: o.legendAlign,
                wrapperStyle: { fontSize: 12, color: colorVar("fg") }
              }
            ),
            series.map((s, i) => /* @__PURE__ */ jsx(
              Bar,
              {
                dataKey: s.dataKey,
                name: s.name,
                fill: seriesColor(s.colorToken, i),
                ...stacked ? { stackId: "stack" } : {},
                radius: stacked ? [0, 0, 0, 0] : [4, 4, 0, 0],
                isAnimationActive: !reduced
              },
              s.dataKey
            ))
          ]
        }
      )
    }
  );
}
function DonutChart({
  data,
  loading,
  empty,
  emptyLabel,
  height = 280,
  className,
  centerLabel,
  ariaLabel
}) {
  const reduced = usePrefersReducedMotion();
  const o = chartOrientation(false);
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const isEmpty = empty ?? (!loading && total === 0);
  const summary = ariaLabel ?? `Donut chart: ${data.map((d) => {
    const pct = total > 0 ? Math.round(d.value / total * 100) : 0;
    return `${d.name} ${d.value} (${pct}%)`;
  }).join(", ")}`;
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsx(
      ChartFrame,
      {
        ...loading !== void 0 ? { loading } : {},
        empty: isEmpty,
        ...emptyLabel !== void 0 ? { emptyLabel } : {},
        height,
        ...className !== void 0 ? { className } : {},
        ariaLabel: summary,
        children: /* @__PURE__ */ jsxs(PieChart, { children: [
          /* @__PURE__ */ jsx(
            Pie,
            {
              data: data.map((d) => ({ ...d })),
              dataKey: "value",
              nameKey: "name",
              innerRadius: "60%",
              outerRadius: "85%",
              paddingAngle: 1,
              startAngle: o.donutStartAngle,
              endAngle: o.donutEndAngle,
              isAnimationActive: !reduced,
              children: data.map((slice, i) => /* @__PURE__ */ jsx(Cell, { fill: seriesColor(slice.colorToken, i) }, slice.name))
            }
          ),
          /* @__PURE__ */ jsx(
            Tooltip$1,
            {
              contentStyle: {
                background: colorVar("surface"),
                border: `1px solid ${colorVar("border")}`,
                borderRadius: 8,
                color: colorVar("fg"),
                fontSize: 12,
                direction: "ltr"
              }
            }
          ),
          /* @__PURE__ */ jsx(
            Legend,
            {
              align: o.legendAlign,
              wrapperStyle: { fontSize: 12, color: colorVar("fg") }
            }
          )
        ] })
      }
    ),
    centerLabel && !loading && !isEmpty ? /* @__PURE__ */ jsx("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx("span", { className: "text-2xl font-semibold text-fg", children: centerLabel }) }) : null
  ] });
}
function groupItems(items) {
  const order = [];
  const map = /* @__PURE__ */ new Map();
  for (const item of items) {
    const existing = map.get(item.group);
    if (existing) {
      existing.push(item);
    } else {
      map.set(item.group, [item]);
      order.push(item.group);
    }
  }
  return order.map((group) => ({ group, items: map.get(group) ?? [] }));
}
function CommandPalette({
  open,
  onOpenChange,
  items = [],
  placeholder = "Type a command or search\u2026",
  emptyMessage = "No results found.",
  query,
  onQueryChange,
  loading = false
}) {
  const groups = React12.useMemo(() => groupItems(items), [items]);
  const serverMode = onQueryChange != null;
  return /* @__PURE__ */ jsxs(
    CommandDialog,
    {
      open,
      onOpenChange,
      ...serverMode ? { shouldFilter: false } : {},
      children: [
        /* @__PURE__ */ jsx(
          CommandInput,
          {
            placeholder,
            ...serverMode ? { value: query ?? "", onValueChange: onQueryChange } : {}
          }
        ),
        /* @__PURE__ */ jsxs(CommandList, { children: [
          loading ? /* @__PURE__ */ jsx(
            "div",
            {
              className: "px-3 py-6 text-center text-sm text-muted",
              role: "status",
              children: "Searching\u2026"
            }
          ) : /* @__PURE__ */ jsx(CommandEmpty, { children: emptyMessage }),
          groups.map(({ group, items: groupEntries }) => /* @__PURE__ */ jsx(CommandGroup, { heading: group, children: groupEntries.map((item) => {
            const Icon2 = item.icon;
            return /* @__PURE__ */ jsxs(
              CommandItem,
              {
                value: serverMode ? item.id : `${item.label} ${(item.keywords ?? []).join(" ")}`,
                onSelect: () => {
                  item.onSelect();
                  onOpenChange(false);
                },
                children: [
                  Icon2 ? /* @__PURE__ */ jsx(Icon2, { "aria-hidden": "true" }) : null,
                  item.label
                ]
              },
              item.id
            );
          }) }, group ?? "_"))
        ] })
      ]
    }
  );
}
function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default",
  onConfirm
}) {
  return /* @__PURE__ */ jsx(AlertDialog, { open, onOpenChange, children: /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
    /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
      /* @__PURE__ */ jsx(AlertDialogTitle, { children: title }),
      description ? /* @__PURE__ */ jsx(AlertDialogDescription, { children: description }) : null
    ] }),
    /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
      /* @__PURE__ */ jsx(AlertDialogCancel, { children: cancelLabel }),
      /* @__PURE__ */ jsx(
        AlertDialogAction,
        {
          className: cn(
            variant === "destructive" && buttonVariants({ variant: "danger" })
          ),
          onClick: onConfirm,
          children: confirmLabel
        }
      )
    ] })
  ] }) });
}
function isErrorEnvelope(value) {
  return ErrorEnvelopeSchema.safeParse(value).success;
}
function extractEnvelope(input) {
  if (isErrorEnvelope(input)) return input;
  if (input && typeof input === "object") {
    const carriers = [
      input.data,
      input.body,
      input.response?.data
    ];
    for (const c of carriers) {
      if (isErrorEnvelope(c)) return c;
    }
  }
  return null;
}
function apiError(input) {
  const envelope = extractEnvelope(input);
  if (envelope) {
    const e = envelope.error;
    const fields = {};
    if (e.fields) {
      for (const [path, fe] of Object.entries(e.fields)) {
        fields[path] = fe.message;
      }
    }
    return {
      code: e.code,
      title: e.message,
      fields,
      retryable: e.retryable,
      requestId: e.requestId
    };
  }
  const title = input instanceof Error ? input.message : typeof input === "string" ? input : "Something went wrong";
  return {
    code: "UNKNOWN",
    title,
    fields: {},
    retryable: false,
    requestId: null
  };
}
function ErrorState({
  error,
  heading,
  body,
  onRetry,
  retryLabel = "Retry",
  className
}) {
  const normalized = error !== void 0 ? apiError(error) : null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(AlertTriangle, { className: "size-10 text-danger", "aria-hidden": true }),
        /* @__PURE__ */ jsx("h3", { className: "text-base font-semibold text-fg", children: heading ?? normalized?.title ?? "Something went wrong" }),
        body ? /* @__PURE__ */ jsx("p", { className: "max-w-sm text-sm text-muted", children: body }) : null,
        onRetry ? /* @__PURE__ */ jsx(Button, { variant: "outline", onClick: onRetry, className: "mt-2", children: retryLabel }) : null
      ]
    }
  );
}
var defaultLabels = {
  rowsPerPage: "Rows per page",
  page: "Page",
  of: "of",
  first: "First page",
  previous: "Previous page",
  next: "Next page",
  last: "Last page"
};
function DataTablePagination({
  table,
  pageSizeOptions = [10, 25, 50, 100],
  labels,
  className
}) {
  const l = { ...defaultLabels, ...labels };
  const { pageIndex, pageSize } = table.getState().pagination;
  const pageCount = Math.max(table.getPageCount(), 1);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-wrap items-center justify-between gap-3 text-sm",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: "text-muted", children: l.rowsPerPage }),
          /* @__PURE__ */ jsx(
            "select",
            {
              className: "h-9 rounded-md border border-input bg-bg px-2 text-sm text-fg focus:outline-none focus:ring-2 focus:ring-ring",
              value: pageSize,
              onChange: (e) => table.setPageSize(Number(e.target.value)),
              "aria-label": l.rowsPerPage,
              children: pageSizeOptions.map((size) => /* @__PURE__ */ jsx("option", { value: size, children: size }, size))
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsxs("span", { className: "text-muted", "aria-live": "polite", children: [
            l.page,
            " ",
            pageIndex + 1,
            " ",
            l.of,
            " ",
            pageCount
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outline",
                size: "icon",
                className: "size-9",
                onClick: () => table.setPageIndex(0),
                disabled: !table.getCanPreviousPage(),
                "aria-label": l.first,
                children: /* @__PURE__ */ jsx(ChevronsLeft, { className: "size-4 rtl:rotate-180", "aria-hidden": true })
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outline",
                size: "icon",
                className: "size-9",
                onClick: () => table.previousPage(),
                disabled: !table.getCanPreviousPage(),
                "aria-label": l.previous,
                children: /* @__PURE__ */ jsx(ChevronLeft, { className: "size-4 rtl:rotate-180", "aria-hidden": true })
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outline",
                size: "icon",
                className: "size-9",
                onClick: () => table.nextPage(),
                disabled: !table.getCanNextPage(),
                "aria-label": l.next,
                children: /* @__PURE__ */ jsx(ChevronRight, { className: "size-4 rtl:rotate-180", "aria-hidden": true })
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "outline",
                size: "icon",
                className: "size-9",
                onClick: () => table.setPageIndex(pageCount - 1),
                disabled: !table.getCanNextPage(),
                "aria-label": l.last,
                children: /* @__PURE__ */ jsx(ChevronsRight, { className: "size-4 rtl:rotate-180", "aria-hidden": true })
              }
            )
          ] })
        ] })
      ]
    }
  );
}
var defaultLabels2 = {
  empty: "No results.",
  retry: "Retry",
  columns: "Columns",
  toggleColumns: "Toggle columns",
  density: "Density",
  comfortable: "Comfortable",
  compact: "Compact",
  pagination: {}
};
var alignClass = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
};
function DataTable(props) {
  const {
    columns,
    data,
    isLoading,
    isError,
    error,
    onRetry,
    emptyState,
    toolbar,
    manualSorting,
    enablePagination = true,
    manualPagination,
    rowCount,
    pageSizeOptions = [10, 25, 50, 100],
    initialPageSize = 10,
    manualFiltering,
    enableColumnVisibility = true,
    enableDensityToggle = true,
    onDensityChange,
    getRowId,
    mobilePrimaryColumns,
    caption,
    className,
    rowTestId,
    onRowClick,
    skeletonRows = 5
  } = props;
  const labels = { ...defaultLabels2, ...props.labels };
  const [internalSorting, setInternalSorting] = React12.useState(
    []
  );
  const sorting = props.sorting ?? internalSorting;
  const onSortingChange = props.onSortingChange ?? setInternalSorting;
  const [internalPagination, setInternalPagination] = React12.useState({
    pageIndex: 0,
    pageSize: initialPageSize
  });
  const pagination = props.pagination ?? internalPagination;
  const onPaginationChange = props.onPaginationChange ?? setInternalPagination;
  const [internalGlobalFilter, setInternalGlobalFilter] = React12.useState("");
  const globalFilter = props.globalFilter ?? internalGlobalFilter;
  const onGlobalFilterChange = props.onGlobalFilterChange ?? setInternalGlobalFilter;
  const [internalVisibility, setInternalVisibility] = React12.useState({});
  const columnVisibility = props.columnVisibility ?? internalVisibility;
  const onColumnVisibilityChange = props.onColumnVisibilityChange ?? setInternalVisibility;
  const [internalSelection, setInternalSelection] = React12.useState({});
  const rowSelection = props.rowSelection ?? internalSelection;
  const onRowSelectionChange = props.onRowSelectionChange ?? setInternalSelection;
  const [internalDensity, setInternalDensity] = React12.useState("comfortable");
  const density = props.density ?? internalDensity;
  const setDensity = (next) => {
    onDensityChange?.(next);
    if (props.density === void 0) setInternalDensity(next);
  };
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      pagination,
      globalFilter,
      columnVisibility,
      rowSelection
    },
    onSortingChange,
    onPaginationChange,
    onGlobalFilterChange,
    onColumnVisibilityChange,
    onRowSelectionChange,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    ...enablePagination ? { getPaginationRowModel: getPaginationRowModel() } : {},
    manualSorting: manualSorting ?? false,
    manualPagination: manualPagination ?? false,
    manualFiltering: manualFiltering ?? false,
    ...rowCount !== void 0 ? { rowCount } : {},
    ...getRowId ? { getRowId } : {},
    enableSortingRemoval: false,
    autoResetPageIndex: !manualPagination
  });
  const cellPad = density === "compact" ? "px-2 py-1" : "px-3 py-2";
  const showPaginationFooter = enablePagination && (manualPagination || table.getPageCount() > 1);
  const densityToggle = enableDensityToggle ? /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant: "outline",
      size: "sm",
      onClick: () => setDensity(density === "compact" ? "comfortable" : "compact"),
      "aria-label": labels.density,
      title: labels.density,
      children: density === "compact" ? labels.comfortable : labels.compact
    }
  ) : null;
  const columnMenu = enableColumnVisibility ? /* @__PURE__ */ jsxs(DropdownMenu, { children: [
    /* @__PURE__ */ jsx(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        "aria-label": labels.toggleColumns,
        children: [
          /* @__PURE__ */ jsx(SlidersHorizontal, { className: "size-4", "aria-hidden": true }),
          labels.columns
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(DropdownMenuContent, { align: "end", className: "min-w-44", children: [
      /* @__PURE__ */ jsx(DropdownMenuLabel, { children: labels.toggleColumns }),
      /* @__PURE__ */ jsx(DropdownMenuSeparator, {}),
      table.getAllLeafColumns().filter((column) => column.getCanHide()).map((column) => {
        const headerDef = column.columnDef.header;
        const meta = column.columnDef.meta;
        const label = meta?.label ?? (typeof headerDef === "string" ? headerDef : column.id);
        return /* @__PURE__ */ jsx(
          DropdownMenuCheckboxItem,
          {
            checked: column.getIsVisible(),
            onCheckedChange: (value) => column.toggleVisibility(Boolean(value)),
            onSelect: (e) => e.preventDefault(),
            children: label
          },
          column.id
        );
      })
    ] })
  ] }) : null;
  const hasControls = Boolean(toolbar) || Boolean(densityToggle) || Boolean(columnMenu);
  function renderBody() {
    if (isError) {
      return /* @__PURE__ */ jsx(
        ErrorState,
        {
          error,
          ...onRetry ? { onRetry } : {},
          retryLabel: labels.retry
        }
      );
    }
    if (isLoading) {
      return /* @__PURE__ */ jsx("div", { className: "space-y-2 p-2", "aria-busy": "true", children: Array.from({ length: skeletonRows }).map((_, i) => /* @__PURE__ */ jsx(Skeleton, { className: "h-9 w-full" }, i)) });
    }
    if (table.getRowModel().rows.length === 0) {
      return emptyState ?? /* @__PURE__ */ jsx(EmptyState, { heading: labels.empty });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "hidden overflow-x-auto rounded-md border border-border md:block", children: /* @__PURE__ */ jsxs("table", { className: "min-w-full text-sm", children: [
        caption ? /* @__PURE__ */ jsx("caption", { className: "sr-only", children: caption }) : null,
        /* @__PURE__ */ jsx("thead", { className: "sticky top-0 z-10 bg-surface", children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx("tr", { className: "border-b border-border", children: headerGroup.headers.map((header) => {
          const meta = header.column.columnDef.meta;
          const align = meta?.align ?? "start";
          const canSort = header.column.getCanSort();
          const sorted = header.column.getIsSorted();
          const content = header.isPlaceholder ? null : flexRender(
            header.column.columnDef.header,
            header.getContext()
          );
          return /* @__PURE__ */ jsx(
            "th",
            {
              className: cn(
                "whitespace-nowrap font-medium text-muted",
                cellPad,
                alignClass[align]
              ),
              "aria-sort": sorted === "asc" ? "ascending" : sorted === "desc" ? "descending" : void 0,
              children: canSort ? /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  onClick: header.column.getToggleSortingHandler(),
                  className: "inline-flex items-center gap-1 hover:text-fg",
                  children: [
                    content,
                    sorted === "asc" ? /* @__PURE__ */ jsx(ArrowUp, { className: "size-3.5", "aria-hidden": true }) : sorted === "desc" ? /* @__PURE__ */ jsx(ArrowDown, { className: "size-3.5", "aria-hidden": true }) : /* @__PURE__ */ jsx(
                      ChevronsUpDown,
                      {
                        className: "size-3.5 opacity-50",
                        "aria-hidden": true
                      }
                    )
                  ]
                }
              ) : content
            },
            header.id
          );
        }) }, headerGroup.id)) }),
        /* @__PURE__ */ jsx("tbody", { children: table.getRowModel().rows.map((row) => /* @__PURE__ */ jsx(
          "tr",
          {
            className: cn(
              "border-b border-border last:border-0",
              onRowClick && "cursor-pointer hover:bg-muted-surface"
            ),
            ...rowTestId ? { "data-testid": rowTestId(row.original) } : {},
            ...onRowClick ? { onClick: () => onRowClick(row.original) } : {},
            children: row.getVisibleCells().map((cell) => {
              const align = cell.column.columnDef.meta?.align ?? "start";
              return /* @__PURE__ */ jsx(
                "td",
                {
                  className: cn("text-fg", cellPad, alignClass[align]),
                  children: flexRender(
                    cell.column.columnDef.cell,
                    cell.getContext()
                  )
                },
                cell.id
              );
            })
          },
          row.id
        )) })
      ] }) }),
      /* @__PURE__ */ jsx("ul", { className: "space-y-3 md:hidden", children: table.getRowModel().rows.map((row) => {
        const cells = row.getVisibleCells().filter((cell) => !cell.column.columnDef.meta?.hideOnMobile);
        const primary = mobilePrimaryColumns?.length ? cells.filter((c) => mobilePrimaryColumns.includes(c.column.id)) : cells.slice(0, 1);
        const rest = cells.filter((c) => !primary.includes(c));
        return /* @__PURE__ */ jsxs(
          "li",
          {
            className: cn(
              "rounded-md border border-border p-3",
              onRowClick && "cursor-pointer hover:bg-muted-surface"
            ),
            ...rowTestId ? { "data-testid": rowTestId(row.original) } : {},
            ...onRowClick ? { onClick: () => onRowClick(row.original) } : {},
            children: [
              primary.map((cell) => /* @__PURE__ */ jsx("div", { className: "font-medium text-fg", children: flexRender(cell.column.columnDef.cell, cell.getContext()) }, cell.id)),
              /* @__PURE__ */ jsx("dl", { className: "mt-2 space-y-1 text-sm", children: rest.map((cell) => {
                const headerDef = cell.column.columnDef.header;
                const meta = cell.column.columnDef.meta;
                const label = meta?.label ?? (typeof headerDef === "string" ? headerDef : cell.column.id);
                return /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "flex items-center justify-between gap-3",
                    children: [
                      /* @__PURE__ */ jsx("dt", { className: "text-muted", children: label }),
                      /* @__PURE__ */ jsx("dd", { className: "text-fg", children: flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      ) })
                    ]
                  },
                  cell.id
                );
              }) })
            ]
          },
          row.id
        );
      }) })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), "data-density": density, children: [
    hasControls ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-1 flex-wrap items-center gap-2", children: toolbar }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        densityToggle,
        columnMenu
      ] })
    ] }) : null,
    renderBody(),
    showPaginationFooter ? /* @__PURE__ */ jsx(
      DataTablePagination,
      {
        table,
        pageSizeOptions,
        labels: labels.pagination
      }
    ) : null
  ] });
}
function DataTableToolbar({
  search,
  filters,
  actions,
  className
}) {
  if (!search && !filters && !actions) return null;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-wrap items-center gap-2", className), children: [
    search,
    filters,
    actions ? /* @__PURE__ */ jsx("div", { className: "ms-auto flex items-center gap-2", children: actions }) : null
  ] });
}
function toDate(input) {
  return input instanceof Date ? input : new Date(input);
}
function localeFor(locale) {
  return (locale ?? "en").toLowerCase().startsWith("ar") ? ar : enUS;
}
function formatDate(input, opts) {
  return format(toDate(input), opts?.pattern ?? "PP", {
    locale: localeFor(opts?.locale)
  });
}
function formatDateTime(input, opts) {
  return format(toDate(input), opts?.pattern ?? "PPp", {
    locale: localeFor(opts?.locale)
  });
}
function DatePicker({
  value,
  onChange,
  onBlur,
  min,
  max,
  disabled,
  placeholder = "Pick a date",
  id,
  name,
  className,
  ...aria
}) {
  const [open, setOpen] = React12.useState(false);
  const disabledMatchers = [];
  if (min) disabledMatchers.push({ before: min });
  if (max) disabledMatchers.push({ after: max });
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open,
      onOpenChange: (o) => {
        setOpen(o);
        if (!o) onBlur?.();
      },
      children: [
        /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
          Button,
          {
            type: "button",
            variant: "outline",
            id,
            name,
            disabled,
            "aria-invalid": aria["aria-invalid"],
            "aria-describedby": aria["aria-describedby"],
            className: cn(
              "w-full justify-start gap-2 font-normal",
              !value && "text-muted",
              className
            ),
            children: [
              /* @__PURE__ */ jsx(Calendar$1, { className: "size-4", "aria-hidden": true }),
              value ? formatDate(value, { locale: "en" }) : placeholder
            ]
          }
        ) }),
        /* @__PURE__ */ jsx(PopoverContent, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ jsx(
          Calendar,
          {
            mode: "single",
            dir: "ltr",
            locale: enUS,
            selected: value,
            onSelect: (d) => {
              onChange?.(d);
              setOpen(false);
            },
            ...disabledMatchers.length ? { disabled: disabledMatchers } : {},
            autoFocus: true
          }
        ) })
      ]
    }
  );
}
function DescriptionList({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "dl",
    {
      className: cn(
        "grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3",
        className
      ),
      ...props
    }
  );
}
function DescriptionItem({
  label,
  children,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: cn("min-w-0", className), children: [
    /* @__PURE__ */ jsx("dt", { className: "text-xs font-medium uppercase tracking-wide text-muted", children: label }),
    /* @__PURE__ */ jsx("dd", { className: "mt-1 break-words text-sm font-medium text-fg", children })
  ] });
}
function defaultPresets() {
  const today = /* @__PURE__ */ new Date();
  return [
    {
      label: "Last 7 days",
      range: () => ({ from: subDays(today, 6), to: today })
    },
    {
      label: "Last 30 days",
      range: () => ({ from: subDays(today, 29), to: today })
    },
    {
      label: "This month",
      range: () => ({ from: startOfMonth(today), to: endOfMonth(today) })
    },
    {
      label: "Last month",
      range: () => {
        const prev = subMonths(today, 1);
        return { from: startOfMonth(prev), to: endOfMonth(prev) };
      }
    }
  ];
}
function DateRangePicker({
  value,
  onChange,
  placeholder = "Pick a date range",
  presets,
  presetsLabel = "Quick ranges",
  disabled,
  className
}) {
  const [open, setOpen] = React12.useState(false);
  const resolved = presets ?? defaultPresets();
  const locale = "en";
  const label = value?.from ? value.to ? `${formatDate(value.from, { locale })} \u2013 ${formatDate(value.to, { locale })}` : formatDate(value.from, { locale }) : placeholder;
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        variant: "outline",
        disabled,
        className: cn(
          "w-full justify-start gap-2 font-normal",
          !value?.from && "text-muted",
          className
        ),
        children: [
          /* @__PURE__ */ jsx(Calendar$1, { className: "size-4", "aria-hidden": true }),
          label
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(
      PopoverContent,
      {
        className: "flex w-auto flex-col gap-3 p-3 sm:flex-row",
        align: "start",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx("span", { className: "px-1 text-xs font-medium text-muted", children: presetsLabel }),
            resolved.map((preset) => /* @__PURE__ */ jsx(
              Button,
              {
                type: "button",
                variant: "ghost",
                size: "sm",
                className: "justify-start font-normal",
                onClick: () => onChange?.(preset.range()),
                children: preset.label
              },
              preset.label
            ))
          ] }),
          /* @__PURE__ */ jsx(
            Calendar,
            {
              mode: "range",
              dir: "ltr",
              locale: enUS,
              numberOfMonths: 2,
              selected: value,
              onSelect: (r) => onChange?.(r),
              autoFocus: true
            }
          )
        ]
      }
    )
  ] });
}
var counter = 0;
var nextId = () => `upload-${++counter}`;
function FileUpload({
  uploader,
  accept,
  maxSizeBytes,
  multiple = false,
  disabled,
  onUploaded,
  label = "Drag files here, or click to browse",
  hint,
  className
}) {
  const [items, setItems] = React12.useState([]);
  const update = React12.useCallback((id, patch) => {
    setItems(
      (prev) => prev.map((it) => it.id === id ? { ...it, ...patch } : it)
    );
  }, []);
  const onDrop = React12.useCallback(
    (accepted) => {
      for (const file of accepted) {
        const id = nextId();
        setItems((prev) => [
          ...prev,
          { id, file, status: "uploading", progress: 0 }
        ]);
        if (!uploader) {
          update(id, { status: "done", progress: 100 });
          continue;
        }
        uploader(file, (pct) => update(id, { progress: pct })).then((ref) => {
          update(id, { status: "done", progress: 100, ref });
          onUploaded?.(ref);
        }).catch((err) => {
          update(id, {
            status: "error",
            error: err instanceof Error ? err.message : String(err)
          });
        });
      }
    },
    [uploader, onUploaded, update]
  );
  const dropzoneOptions = { onDrop, multiple };
  if (accept) {
    dropzoneOptions.accept = Object.fromEntries(
      accept.map((m) => [m, []])
    );
  }
  if (maxSizeBytes !== void 0) dropzoneOptions.maxSize = maxSizeBytes;
  if (disabled !== void 0) dropzoneOptions.disabled = disabled;
  const { getRootProps, getInputProps, isDragActive } = useDropzone(dropzoneOptions);
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        ...getRootProps(),
        className: cn(
          "flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-border px-6 py-8 text-center transition-colors",
          "hover:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          isDragActive && "border-primary bg-primary/5",
          disabled && "cursor-not-allowed opacity-50"
        ),
        children: [
          /* @__PURE__ */ jsx("input", { ...getInputProps(), "aria-label": label }),
          /* @__PURE__ */ jsx(UploadCloud, { className: "size-8 text-muted", "aria-hidden": true }),
          /* @__PURE__ */ jsx("p", { className: "text-sm text-fg", children: label }),
          hint ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted", children: hint }) : null
        ]
      }
    ),
    items.length > 0 ? /* @__PURE__ */ jsx("ul", { className: "space-y-2", children: items.map((it) => /* @__PURE__ */ jsxs(
      "li",
      {
        className: "flex items-center gap-3 rounded-md border border-border p-2",
        children: [
          /* @__PURE__ */ jsx(File, { className: "size-4 shrink-0 text-muted", "aria-hidden": true }),
          /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ jsx("p", { className: "truncate text-sm text-fg", children: it.file.name }),
            it.status === "uploading" ? /* @__PURE__ */ jsx(Progress, { value: it.progress, className: "mt-1 h-1" }) : it.status === "error" ? /* @__PURE__ */ jsx("p", { className: "text-xs text-danger", children: it.error }) : null
          ] }),
          it.status === "uploading" ? /* @__PURE__ */ jsx(
            Loader2,
            {
              className: "size-4 shrink-0 animate-spin text-muted",
              "aria-hidden": true
            }
          ) : it.status === "done" ? /* @__PURE__ */ jsx(
            CheckCircle2,
            {
              className: "size-4 shrink-0 text-success",
              "aria-hidden": true
            }
          ) : /* @__PURE__ */ jsx(
            AlertCircle,
            {
              className: "size-4 shrink-0 text-danger",
              "aria-hidden": true
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              variant: "ghost",
              size: "icon",
              className: "size-7 shrink-0",
              "aria-label": "Remove",
              onClick: () => setItems((prev) => prev.filter((p) => p.id !== it.id)),
              children: /* @__PURE__ */ jsx(X, { className: "size-4", "aria-hidden": true })
            }
          )
        ]
      },
      it.id
    )) }) : null
  ] });
}
function Form({
  form,
  onSubmit,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(FormProvider, { ...form, children: /* @__PURE__ */ jsx("form", { onSubmit: form.handleSubmit(onSubmit), noValidate: true, ...props, children }) });
}
function resolveError(errors, name) {
  const node = name.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object") {
      return acc[key];
    }
    return void 0;
  }, errors);
  return node && typeof node === "object" ? node : void 0;
}
function FormField({
  name,
  label,
  description,
  required,
  className,
  children
}) {
  const { errors } = useFormState({ name });
  const error = resolveError(errors, name);
  const message = typeof error?.message === "string" ? error.message : void 0;
  const controlId = name;
  const errorId = `${name}-error`;
  const descId = `${name}-description`;
  const describedBy = [message ? errorId : null, description ? descId : null].filter(Boolean).join(" ") || void 0;
  const control = React12.isValidElement(children) ? React12.cloneElement(
    children,
    {
      id: children.props.id ?? controlId,
      "aria-invalid": message ? true : void 0,
      "aria-describedby": describedBy
    }
  ) : children;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col gap-1.5", className), children: [
    label ? /* @__PURE__ */ jsxs(Label3, { htmlFor: controlId, children: [
      label,
      required ? /* @__PURE__ */ jsx("span", { className: "ms-0.5 text-danger", "aria-hidden": "true", children: "*" }) : null
    ] }) : null,
    control,
    message ? /* @__PURE__ */ jsx("p", { id: errorId, "data-testid": errorId, className: "text-sm text-danger", children: message }) : description ? /* @__PURE__ */ jsx("p", { id: descId, className: "text-sm text-muted", children: description }) : null
  ] });
}
function FormGrid({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-4",
        className
      ),
      ...props
    }
  );
}
function FormSectionTitle({
  title,
  description,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: cn("sm:col-span-2 lg:col-span-4", className), children: [
    /* @__PURE__ */ jsx("h3", { className: "text-sm font-semibold text-fg", children: title }),
    description ? /* @__PURE__ */ jsx("p", { className: "mt-0.5 text-sm text-muted", children: description }) : null
  ] });
}
function FormActions({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "sticky bottom-0 z-10 -mx-4 -mb-4 mt-2 flex flex-col-reverse gap-3 border-t border-border bg-surface px-4 py-3 md:-mx-6 md:-mb-6 md:px-6",
        "shadow-[0_-1px_3px_rgba(0,0,0,0.04)]",
        "sm:flex-row sm:items-center sm:justify-end",
        className
      ),
      ...props
    }
  );
}
var toneToColorToken = {
  default: "primary",
  secondary: "muted",
  success: "success",
  warn: "warn",
  danger: "danger",
  info: "info"
};
function KPICard({
  label,
  value,
  sublabel,
  tone = "default",
  loading = false,
  error = false,
  onRetry,
  retryLabel,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex min-h-28 flex-col gap-2 rounded-lg border border-border bg-surface p-5 shadow-sm",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
          tone !== "default" ? /* @__PURE__ */ jsx(
            "span",
            {
              "aria-hidden": true,
              className: "size-2.5 shrink-0 rounded-full",
              style: { backgroundColor: colorVar(toneToColorToken[tone]) }
            }
          ) : null,
          /* @__PURE__ */ jsx("span", { className: "text-xs font-semibold uppercase tracking-wide text-muted", children: label })
        ] }),
        error ? /* @__PURE__ */ jsx(
          ErrorState,
          {
            className: "px-0 py-2",
            ...onRetry ? { onRetry } : {},
            ...retryLabel ? { retryLabel } : {}
          }
        ) : loading ? /* @__PURE__ */ jsxs("div", { className: "space-y-2 pt-1", role: "status", "aria-live": "polite", children: [
          /* @__PURE__ */ jsx(Skeleton, { className: "h-8 w-24" }),
          /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-32" })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "text-3xl font-semibold leading-tight text-fg", children: value }),
          sublabel ? /* @__PURE__ */ jsx("div", { className: "text-sm text-muted", children: sublabel }) : null
        ] })
      ]
    }
  );
}
function LoadingState({
  variant = "spinner",
  label,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: cn(
        "flex flex-col items-center justify-center gap-2 text-muted",
        variant === "full-page" ? "min-h-64 w-full" : "py-6",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Loader2, { className: "size-6 animate-spin", "aria-hidden": true }),
        label ? /* @__PURE__ */ jsx("span", { className: "text-sm", children: label }) : null
      ]
    }
  );
}
var CURRENCY_DECIMALS = {};
function decimalsFor(currency) {
  return CURRENCY_DECIMALS[currency] ?? 2;
}
function formatMoney(money, opts) {
  const locale = opts?.locale ?? "en-IN";
  const withCurrency = opts?.withCurrency ?? true;
  const decimals = decimalsFor(money.currency);
  const formatter = new Intl.NumberFormat(locale, {
    style: withCurrency ? "currency" : "decimal",
    currency: money.currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  return formatter.format(moneyToDecimal(money).toNumber());
}
function formatMoneyValue(value, currency = "INR", opts) {
  return formatMoney({ value, currency }, opts);
}
function MoneyDisplay({ value, className }) {
  return /* @__PURE__ */ jsx("span", { dir: "ltr", className: cn("tabular-nums", className), children: formatMoney(value, { locale: "en-IN" }) });
}
var CURRENCY_DECIMALS2 = {};
function decimalsFor2(currency) {
  return CURRENCY_DECIMALS2[currency] ?? 2;
}
function sanitize(raw, max) {
  let s = raw.replace(/[^0-9.]/g, "");
  const firstDot = s.indexOf(".");
  if (firstDot !== -1) {
    const intPart = s.slice(0, firstDot);
    const fracPart = s.slice(firstDot + 1).replace(/\./g, "");
    s = `${intPart}.${fracPart.slice(0, max)}`;
  }
  return s;
}
function normalize(text, max) {
  if (text === "" || text === ".") return "";
  try {
    return new Decimal(text).toFixed(max);
  } catch {
    return text;
  }
}
var MoneyInput = React12.forwardRef(
  function MoneyInput2({
    value,
    onChange,
    onBlur,
    currency = "INR",
    className,
    placeholder,
    ...props
  }, ref) {
    const max = decimalsFor2(currency);
    const external = value?.value ?? "";
    const [focused, setFocused] = React12.useState(false);
    const [text, setText] = React12.useState(external);
    const display = focused ? text : external;
    return /* @__PURE__ */ jsxs("div", { className: cn("relative", className), children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          ...props,
          ref,
          type: "text",
          inputMode: "decimal",
          dir: "ltr",
          autoComplete: "off",
          placeholder,
          className: "pe-14 text-end tabular-nums",
          value: display,
          onFocus: () => {
            setText(external);
            setFocused(true);
          },
          onChange: (e) => {
            const next = sanitize(e.target.value, max);
            setText(next);
            onChange?.({ value: next, currency });
          },
          onBlur: () => {
            setFocused(false);
            const norm = normalize(text, max);
            if (norm !== external) onChange?.({ value: norm, currency });
            onBlur?.();
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "span",
        {
          "aria-hidden": true,
          className: "pointer-events-none absolute inset-y-0 end-3 flex items-center text-sm text-muted",
          children: currency
        }
      )
    ] });
  }
);
function PageHeader({
  title,
  description,
  breadcrumbs,
  actions,
  onBack,
  className
}) {
  return /* @__PURE__ */ jsxs("header", { className: cn("flex flex-col gap-2", className), children: [
    breadcrumbs,
    /* @__PURE__ */ jsxs("div", { className: "flex items-start justify-between gap-4", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        onBack ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "icon",
            onClick: onBack,
            "aria-label": "Back",
            children: /* @__PURE__ */ jsx(ArrowLeft, { className: "size-4 rtl:rotate-180" })
          }
        ) : null,
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ jsx("h1", { className: "text-xl font-semibold text-fg", children: title }),
          description ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted", children: description }) : null
        ] })
      ] }),
      actions ? /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2", children: actions }) : null
    ] })
  ] });
}
function Can({ permission, fallback = null, children }) {
  const allowed = usePermission(permission);
  return /* @__PURE__ */ jsx(Fragment, { children: allowed ? children : fallback });
}
var DEFAULT_COUNTRY = "BH";
function formatPhone(e164, opts) {
  const parsed = parsePhoneNumberFromString(e164);
  if (!parsed) return e164;
  return opts?.style === "national" ? parsed.formatNational() : parsed.formatInternational();
}
function toE164(input, country = DEFAULT_COUNTRY) {
  const parsed = parsePhoneNumberFromString(input, country);
  return parsed?.isValid() ? parsed.number : void 0;
}
function isValidPhone(input, country = DEFAULT_COUNTRY) {
  return parsePhoneNumberFromString(input, country)?.isValid() ?? false;
}
var COUNTRIES = [
  "BH",
  "SA",
  "AE",
  "KW",
  "OM",
  "QA",
  "IN",
  "PK",
  "PH",
  "GB",
  "US",
  "EG"
];
function PhoneInput({
  value,
  onChange,
  onBlur,
  defaultCountry = "BH",
  id,
  name,
  disabled,
  placeholder,
  className,
  ...aria
}) {
  const [country, setCountry] = React12.useState(defaultCountry);
  const [focused, setFocused] = React12.useState(false);
  const [text, setText] = React12.useState(value ?? "");
  const display = focused ? text : value ? formatPhone(value) : "";
  function emit(raw, c) {
    onChange?.(toE164(raw, c) ?? raw);
  }
  return /* @__PURE__ */ jsxs("div", { className: cn("flex gap-2", className), children: [
    /* @__PURE__ */ jsxs(
      Select,
      {
        value: country,
        onValueChange: (c) => {
          const next = c;
          setCountry(next);
          emit(text || value || "", next);
        },
        disabled: disabled ?? false,
        children: [
          /* @__PURE__ */ jsx(SelectTrigger, { className: "w-28 shrink-0", "aria-label": "Country code", children: /* @__PURE__ */ jsx(SelectValue, {}) }),
          /* @__PURE__ */ jsx(SelectContent, { children: COUNTRIES.map((c) => /* @__PURE__ */ jsxs(SelectItem, { value: c, children: [
            c,
            " +",
            getCountryCallingCode(c)
          ] }, c)) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Input,
      {
        ...aria,
        id,
        name,
        type: "tel",
        inputMode: "tel",
        dir: "ltr",
        autoComplete: "tel",
        disabled,
        placeholder: placeholder ?? `+${getCountryCallingCode(country)} \u2026`,
        value: display,
        onFocus: () => {
          setText(value ?? "");
          setFocused(true);
        },
        onChange: (e) => {
          setText(e.target.value);
          emit(e.target.value, country);
        },
        onBlur: () => {
          setFocused(false);
          onBlur?.();
        }
      }
    )
  ] });
}
function ResourceDetail({
  title,
  subtitle,
  rail,
  children,
  className
}) {
  const hasHeader = title != null || subtitle != null;
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-6", className), children: [
    hasHeader ? /* @__PURE__ */ jsxs("header", { className: "space-y-1", children: [
      title != null ? /* @__PURE__ */ jsx("h2", { className: "text-xl font-semibold text-fg", children: title }) : null,
      subtitle != null ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted", children: subtitle }) : null
    ] }) : null,
    rail != null ? /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-[1.7fr_1fr]", children: [
      /* @__PURE__ */ jsx("div", { className: "min-w-0", children }),
      /* @__PURE__ */ jsx("aside", { className: "space-y-4", children: rail })
    ] }) : /* @__PURE__ */ jsx("div", { className: "min-w-0", children })
  ] });
}
ResourceDetail.displayName = "ResourceDetail";

// src/patterns/resource-list.tsx
function ResourceList(_props) {
  return null;
}
function TableSkeleton({
  rows = 5,
  columns = 4,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: cn("w-full space-y-2", className),
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex gap-3 border-b border-border pb-2", children: Array.from({ length: columns }).map((_, i) => /* @__PURE__ */ jsx(Skeleton, { className: "h-4 flex-1" }, i)) }),
        Array.from({ length: rows }).map((_, r) => /* @__PURE__ */ jsx("div", { className: "flex gap-3 py-1", children: Array.from({ length: columns }).map((_2, c) => /* @__PURE__ */ jsx(Skeleton, { className: "h-9 flex-1" }, c)) }, r))
      ]
    }
  );
}
function DetailSkeleton({ rows = 6, className }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: cn("space-y-4", className),
      children: [
        /* @__PURE__ */ jsx(Skeleton, { className: "h-7 w-48" }),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-72" }),
        /* @__PURE__ */ jsx("div", { className: "space-y-3 pt-2", children: Array.from({ length: rows }).map((_, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-32" }),
          /* @__PURE__ */ jsx(Skeleton, { className: "h-4 flex-1" })
        ] }, i)) })
      ]
    }
  );
}
function CardListSkeleton({
  count = 3,
  className
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: cn("space-y-3", className),
      children: Array.from({ length: count }).map((_, i) => /* @__PURE__ */ jsxs("div", { className: "space-y-2 rounded-lg border border-border p-4", children: [
        /* @__PURE__ */ jsx(Skeleton, { className: "h-5 w-40" }),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-full" }),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-2/3" })
      ] }, i))
    }
  );
}
function FormSkeleton({ fields = 4, className }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: cn("max-w-lg space-y-4", className),
      children: [
        Array.from({ length: fields }).map((_, i) => /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
          /* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-24" }),
          /* @__PURE__ */ jsx(Skeleton, { className: "h-10 w-full" })
        ] }, i)),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-10 w-32" })
      ]
    }
  );
}
var ALL_BRANCHES = "all";
function StatPageHeader({
  title,
  description,
  breadcrumbs,
  actions,
  onBack,
  branches,
  selectedBranchId,
  onBranchChange,
  branchLabel = "Branch",
  hideBranchSelector = false,
  period,
  className
}) {
  const branchOptions = !hideBranchSelector && branches !== void 0 && branches.length > 0 ? branches : null;
  const controls = branchOptions || period ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
    branchOptions ? /* @__PURE__ */ jsxs(
      Select,
      {
        ...selectedBranchId !== void 0 ? { value: selectedBranchId } : {},
        onValueChange: (v) => onBranchChange?.(v),
        children: [
          /* @__PURE__ */ jsx(
            SelectTrigger,
            {
              className: "h-9 w-48",
              "aria-label": branchLabel,
              "data-testid": "branch-selector",
              children: /* @__PURE__ */ jsx(SelectValue, { placeholder: branchLabel })
            }
          ),
          /* @__PURE__ */ jsx(SelectContent, { children: branchOptions.map((b) => /* @__PURE__ */ jsx(SelectItem, { value: b.id, children: b.label }, b.id)) })
        ]
      }
    ) : null,
    period
  ] }) : null;
  const mergedActions = controls || actions ? /* @__PURE__ */ jsxs(Fragment, { children: [
    controls,
    actions
  ] }) : void 0;
  return /* @__PURE__ */ jsx(
    PageHeader,
    {
      title,
      ...description !== void 0 ? { description } : {},
      ...breadcrumbs !== void 0 ? { breadcrumbs } : {},
      ...onBack !== void 0 ? { onBack } : {},
      ...mergedActions !== void 0 ? { actions: mergedActions } : {},
      ...className !== void 0 ? { className } : {}
    }
  );
}
var toneToVariant = {
  default: "primarySoft",
  secondary: "neutralSoft",
  success: "successSoft",
  warn: "warnSoft",
  danger: "dangerSoft",
  info: "infoSoft"
};
function StatusBadge({
  label,
  tone = "default",
  className
}) {
  return /* @__PURE__ */ jsx(Badge, { variant: toneToVariant[tone], className, children: label });
}
var statusToneMap = {
  ACTIVE: "success",
  PENDING: "warn",
  RENEWAL: "warn",
  RENEWAL_DUE: "warn",
  OVERDUE: "danger",
  TERMINATED: "danger",
  EXPIRED: "danger",
  DRAFT: "info",
  // Billing — invoices.
  ISSUED: "info",
  PARTIALLY_PAID: "warn",
  PAID: "success",
  // Billing — payments.
  SUCCEEDED: "success",
  FAILED: "danger",
  REFUNDED: "secondary",
  PARTIALLY_REFUNDED: "warn",
  // Billing — credit notes.
  APPLIED: "success",
  PARTIALLY_APPLIED: "warn",
  // Finance — journals.
  POSTED: "success",
  REVERSED: "secondary",
  // Finance — accounting periods.
  OPEN: "info",
  CLOSING: "warn",
  LOCKED: "secondary",
  // Finance — VAT returns.
  GENERATED: "info",
  FILED: "success",
  // Finance — bank reconciliation match status.
  UNMATCHED: "secondary",
  MATCHED: "success",
  REVIEW: "warn",
  CONFIRMED: "success",
  // Maintenance — work orders.
  NEW: "info",
  TRIAGED: "info",
  DISPATCHED: "info",
  ACCEPTED: "info",
  IN_PROGRESS: "info",
  AWAITING_QUOTE: "warn",
  AWAITING_PARTS: "warn",
  AWAITING_TENANT: "warn",
  COMPLETED: "success",
  // Dunning stages — escalating severity.
  NONE: "secondary",
  SOFT: "info",
  FIRM: "warn",
  MANAGER: "warn",
  NOTICE: "danger",
  LEGAL: "danger",
  // Onboarding application statuses.
  SUBMITTED: "info",
  EMAIL_VERIFIED: "info",
  CHANGES_REQUESTED: "warn",
  APPROVED: "success",
  REJECTED: "danger",
  // Procurement (Sprint 12) — supplier / PO / GRN / vendor-invoice statuses not
  // already mapped above (PENDING, ISSUED, SUBMITTED, APPROVED, REJECTED,
  // MATCHED, ACCEPTED, DRAFT, ARCHIVED, CANCELLED, CLOSED are reused as-is).
  SUSPENDED_DOC_EXPIRED: "danger",
  SUSPENDED_PERFORMANCE: "danger",
  PARTIALLY_RECEIVED: "warn",
  RECEIVED: "success",
  INVOICED: "info",
  ACKNOWLEDGED: "info",
  THREE_WAY_MATCHED: "success",
  DISPUTED: "danger",
  PARTIAL: "warn",
  SCHEDULED: "success",
  // Maintenance (Sprint 8) — work-order priorities (lifecycle statuses NEW,
  // TRIAGED, DISPATCHED, ACCEPTED, IN_PROGRESS, AWAITING_*, COMPLETED are
  // already mapped above).
  LOW: "secondary",
  MEDIUM: "info",
  HIGH: "warn",
  URGENT: "danger",
  EMERGENCY: "danger",
  // Recognized-but-inactive/terminal statuses: quiet `secondary`, not the loud
  // near-black `default`.
  ARCHIVED: "secondary",
  INACTIVE: "secondary",
  CLOSED: "secondary",
  SUSPENDED: "secondary",
  CANCELLED: "secondary",
  CANCELED: "secondary",
  VOID: "secondary",
  INVALID: "secondary",
  // Complaint/work-order decline (Phase 6) — terminal rejection at intake.
  DECLINED: "danger",
  // Notification broadcast + delivery status (Phase 7).
  QUEUED: "info",
  SENT: "success",
  SKIPPED: "secondary",
  // Asset verification — item outcomes + not-audited visit + replacement request
  // (SCHEDULED, IN_PROGRESS, COMPLETED, CANCELLED, APPROVED, REJECTED, ISSUED,
  // PENDING are reused from above).
  VERIFIED: "success",
  MISSING: "danger",
  DAMAGED: "danger",
  NEEDS_REPLACEMENT: "warn",
  NOT_AUDITED: "warn",
  REQUESTED: "info"
};
function statusTone(status) {
  return statusToneMap[status.trim().toUpperCase()] ?? "default";
}
var STORAGE_KEY = "yk.ui.theme";
function isBrowser() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}
function systemPrefersDark() {
  if (!isBrowser()) return false;
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
}
function readStoredChoice() {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "light" || v === "dark" || v === "system" ? v : null;
  } catch {
    return null;
  }
}
function writeStoredChoice(choice) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, choice);
  } catch {
  }
}
function resolveChoice(choice) {
  if (choice === "system") return systemPrefersDark() ? "dark" : "light";
  return choice;
}
function initialChoice() {
  return readStoredChoice() ?? "system";
}
var useTheme = create((set, get) => {
  const theme = initialChoice();
  return {
    theme,
    resolved: resolveChoice(theme),
    setTheme: (next) => {
      writeStoredChoice(next);
      set({ theme: next, resolved: resolveChoice(next) });
    },
    /** Flip between light and dark. From `system`, flip relative to what the
     *  OS currently resolves to, so the toggle always changes the look. */
    toggleTheme: () => {
      const next = get().resolved === "dark" ? "light" : "dark";
      writeStoredChoice(next);
      set({ theme: next, resolved: next });
    }
  };
});
function useSystemThemeSync() {
  const theme = useTheme((s) => s.theme);
  React12.useEffect(() => {
    if (theme !== "system" || !isBrowser()) return;
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    useTheme.setState({ resolved: mql.matches ? "dark" : "light" });
    const onChange = (e) => {
      useTheme.setState({ resolved: e.matches ? "dark" : "light" });
    };
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [theme]);
}
function ThemeToggle({
  label = "Toggle theme",
  className
}) {
  const resolved = useTheme((s) => s.resolved);
  const toggleTheme = useTheme((s) => s.toggleTheme);
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant: "ghost",
      size: "icon",
      onClick: toggleTheme,
      "aria-label": label,
      className,
      "data-testid": "theme-toggle",
      children: resolved === "dark" ? /* @__PURE__ */ jsx(Sun, { className: "size-4", "aria-hidden": "true" }) : /* @__PURE__ */ jsx(Moon, { className: "size-4", "aria-hidden": "true" })
    }
  );
}
var SIDEBAR_STORAGE_KEY = "yk.ui.sidebar.collapsed";
function useCollapsed() {
  const [collapsed, setCollapsed] = React12.useState(() => {
    if (typeof window === "undefined") return false;
    try {
      return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const toggle = React12.useCallback(() => {
    setCollapsed((c) => {
      const next = !c;
      try {
        window.localStorage.setItem(SIDEBAR_STORAGE_KEY, next ? "1" : "0");
      } catch {
      }
      return next;
    });
  }, []);
  return [collapsed, toggle];
}
function AppShell({
  navItems,
  currentPath,
  linkComponent = DefaultShellLink,
  brand,
  sidebarFooter,
  navSectionLabel = "WORKSPACE",
  title,
  topbarEnd,
  breadcrumbs,
  commandPaletteItems,
  commandPalettePlaceholder,
  commandPaletteEmptyMessage,
  commandPaletteQuery,
  commandPaletteOnQueryChange,
  commandPaletteLoading,
  searchLabel = "Search\u2026",
  children
}) {
  const [collapsed, toggleCollapsed] = useCollapsed();
  const [drawerOpen, setDrawerOpen] = React12.useState(false);
  const [paletteOpen, setPaletteOpen] = React12.useState(false);
  React12.useEffect(() => {
    setDrawerOpen(false);
  }, [currentPath]);
  React12.useEffect(() => {
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "flex h-dvh overflow-hidden bg-bg text-fg", children: [
    /* @__PURE__ */ jsxs(
      "aside",
      {
        className: cn(
          "hidden shrink-0 flex-col border-e border-border bg-surface md:flex",
          collapsed ? "w-16" : "w-60"
        ),
        "data-testid": "app-sidebar",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex h-16 items-center gap-2 px-3", children: [
            !collapsed && brand ? /* @__PURE__ */ jsx("div", { className: "min-w-0 flex-1 truncate", children: brand }) : null,
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "icon",
                onClick: toggleCollapsed,
                "aria-label": "Toggle sidebar",
                "aria-pressed": collapsed,
                className: cn(collapsed && "mx-auto"),
                children: collapsed ? /* @__PURE__ */ jsx(PanelLeft, { className: "size-4" }) : /* @__PURE__ */ jsx(PanelLeftClose, { className: "size-4" })
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex-1 overflow-y-auto px-3 pb-3", children: [
            !collapsed && navSectionLabel ? /* @__PURE__ */ jsx("p", { className: "px-3 pb-2 pt-1 text-xs font-semibold uppercase tracking-wider text-muted", children: navSectionLabel }) : null,
            /* @__PURE__ */ jsx(
              SideNav,
              {
                items: navItems,
                currentPath,
                linkComponent,
                collapsed
              }
            )
          ] }),
          sidebarFooter ? /* @__PURE__ */ jsx("div", { className: "border-t border-border p-3", children: sidebarFooter }) : null
        ]
      }
    ),
    /* @__PURE__ */ jsx(Sheet, { open: drawerOpen, onOpenChange: setDrawerOpen, children: /* @__PURE__ */ jsxs(SheetContent, { side: "left", className: "flex w-72 flex-col gap-0 p-0", children: [
      /* @__PURE__ */ jsx(SheetTitle, { className: "flex h-16 items-center border-b border-border px-4", children: brand }),
      /* @__PURE__ */ jsxs("div", { className: "flex-1 overflow-y-auto p-3", children: [
        navSectionLabel ? /* @__PURE__ */ jsx("p", { className: "px-3 pb-2 pt-1 text-xs font-semibold uppercase tracking-wider text-muted", children: navSectionLabel }) : null,
        /* @__PURE__ */ jsx(
          SideNav,
          {
            items: navItems,
            currentPath,
            linkComponent,
            onNavigate: () => setDrawerOpen(false)
          }
        )
      ] }),
      sidebarFooter ? /* @__PURE__ */ jsx("div", { className: "border-t border-border p-3", children: sidebarFooter }) : null
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-1 flex-col", children: [
      /* @__PURE__ */ jsxs("header", { className: "sticky top-0 z-sticky flex h-14 items-center gap-3 border-b border-border bg-surface px-4", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "icon",
            className: "md:hidden",
            onClick: () => setDrawerOpen(true),
            "aria-label": "Open navigation",
            "data-testid": "nav-drawer-trigger",
            children: /* @__PURE__ */ jsx(Menu, { className: "size-5" })
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "hidden min-w-0 flex-1 truncate text-base font-semibold text-fg md:block", children: title ?? breadcrumbs }),
        /* @__PURE__ */ jsx("div", { className: "hidden flex-1 justify-center px-4 lg:flex", children: /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: () => setPaletteOpen(true),
            className: "inline-flex w-full max-w-md items-center gap-2 rounded-full border border-border bg-bg px-4 py-2 text-sm text-muted transition-colors hover:bg-muted/10",
            "data-testid": "command-palette-trigger",
            children: [
              /* @__PURE__ */ jsx(Search, { className: "size-4 shrink-0", "aria-hidden": "true" }),
              /* @__PURE__ */ jsx("span", { className: "flex-1 text-start", children: searchLabel }),
              /* @__PURE__ */ jsx("kbd", { className: "rounded border border-border bg-surface px-1.5 font-mono text-xs", children: "\u2318K" })
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-1 items-center justify-end gap-2 md:flex-none", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: () => setPaletteOpen(true),
              className: "inline-flex items-center gap-2 rounded-full border border-border bg-bg p-2 text-sm text-muted transition-colors hover:bg-muted/10 lg:hidden",
              "aria-label": searchLabel,
              children: /* @__PURE__ */ jsx(Search, { className: "size-4 shrink-0", "aria-hidden": "true" })
            }
          ),
          /* @__PURE__ */ jsx(ThemeToggle, {}),
          topbarEnd
        ] })
      ] }),
      /* @__PURE__ */ jsx("main", { className: "flex-1 overflow-y-auto p-4 md:p-6", children })
    ] }),
    /* @__PURE__ */ jsx(
      CommandPalette,
      {
        open: paletteOpen,
        onOpenChange: setPaletteOpen,
        items: commandPaletteItems,
        placeholder: commandPalettePlaceholder,
        emptyMessage: commandPaletteEmptyMessage,
        query: commandPaletteQuery,
        onQueryChange: commandPaletteOnQueryChange,
        loading: commandPaletteLoading
      }
    )
  ] });
}
function AuthLayout({
  brand,
  footer,
  children,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex min-h-dvh flex-col items-center justify-center gap-6 bg-bg p-4",
        className
      ),
      children: [
        brand ? /* @__PURE__ */ jsx("div", { className: "flex justify-center", children: brand }) : null,
        /* @__PURE__ */ jsx("div", { className: "w-full max-w-sm rounded-lg border border-border bg-surface p-6 shadow-sm", children }),
        footer ? /* @__PURE__ */ jsx("div", { className: "text-sm text-muted", children: footer }) : null
      ]
    }
  );
}
function MobileShell({
  navItems,
  currentPath,
  linkComponent = DefaultShellLink,
  title,
  topbarEnd,
  children
}) {
  const [drawerOpen, setDrawerOpen] = React12.useState(false);
  React12.useEffect(() => {
    setDrawerOpen(false);
  }, [currentPath]);
  return /* @__PURE__ */ jsxs("div", { className: "flex min-h-dvh flex-col bg-bg text-fg", children: [
    /* @__PURE__ */ jsxs("header", { className: "sticky top-0 z-sticky flex h-14 items-center gap-3 border-b border-border bg-surface px-4", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "icon",
          onClick: () => setDrawerOpen(true),
          "aria-label": "Open navigation",
          children: /* @__PURE__ */ jsx(Menu, { className: "size-5" })
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "min-w-0 flex-1 truncate font-semibold", children: title }),
      topbarEnd
    ] }),
    /* @__PURE__ */ jsx(Sheet, { open: drawerOpen, onOpenChange: setDrawerOpen, children: /* @__PURE__ */ jsxs(SheetContent, { side: "left", className: "w-72 gap-0 p-0", children: [
      /* @__PURE__ */ jsx(SheetTitle, { className: "flex h-14 items-center border-b border-border px-4", children: title }),
      /* @__PURE__ */ jsx("div", { className: "flex-1 overflow-y-auto p-3", children: /* @__PURE__ */ jsx(
        SideNav,
        {
          items: navItems,
          currentPath,
          linkComponent,
          onNavigate: () => setDrawerOpen(false)
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsx("main", { className: "flex-1 overflow-y-auto p-4", children })
  ] });
}

// src/lib/brand-overlay.ts
var ORG_THEME_STYLE_ID = "org-theme";
function hexToRgbChannels(hex) {
  if (typeof hex !== "string") return null;
  const m = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(hex.trim());
  const raw = m?.[1];
  if (!raw) return null;
  const body = raw.length === 3 ? raw.split("").map((c) => c + c).join("") : raw;
  const r = parseInt(body.slice(0, 2), 16);
  const g = parseInt(body.slice(2, 4), 16);
  const b = parseInt(body.slice(4, 6), 16);
  return `${r} ${g} ${b}`;
}
function buildOrgThemeCss(brand) {
  if (!brand) return "";
  const decls = [];
  const primary = hexToRgbChannels(brand.primaryHex);
  if (primary) decls.push(`--color-primary: ${primary};`);
  const accent = hexToRgbChannels(brand.accentHex);
  if (accent) decls.push(`--color-accent: ${accent};`);
  if (brand.fontFamily && brand.fontFamily.trim()) {
    decls.push(`--font-sans: ${brand.fontFamily.trim()};`);
  }
  if (decls.length === 0) return "";
  return `:root { ${decls.join(" ")} }`;
}
function syncOrgThemeElement(brand, doc = document) {
  const css = buildOrgThemeCss(brand);
  const existing = doc.getElementById(
    ORG_THEME_STYLE_ID
  );
  if (!css) {
    if (existing) existing.remove();
    return;
  }
  if (existing) {
    if (existing.textContent !== css) existing.textContent = css;
    return;
  }
  const el = doc.createElement("style");
  el.id = ORG_THEME_STYLE_ID;
  el.textContent = css;
  doc.head.appendChild(el);
}
function ThemeProvider({ children, can, brand }) {
  const resolved = useTheme((s) => s.resolved);
  useSystemThemeSync();
  React12.useEffect(() => {
    document.documentElement.dataset.theme = resolved;
  }, [resolved]);
  React12.useEffect(() => {
    syncOrgThemeElement(brand);
  }, [brand?.primaryHex, brand?.accentHex, brand?.fontFamily]);
  const withPermissions = can ? /* @__PURE__ */ jsx(PermissionProvider, { can, children }) : children;
  return /* @__PURE__ */ jsxs(TooltipProvider, { children: [
    /* @__PURE__ */ jsx(ConfirmProvider, { children: withPermissions }),
    /* @__PURE__ */ jsx(Toaster, { dir: "ltr", richColors: true, closeButton: true, position: "top-center" })
  ] });
}
function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = React12.useState(value);
  React12.useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
function usePageTitle(title, opts) {
  const suffix = opts?.suffix;
  React12.useEffect(() => {
    const previous = document.title;
    document.title = suffix ? `${title} \xB7 ${suffix}` : title;
    return () => {
      document.title = previous;
    };
  }, [title, suffix]);
}
function useToast() {
  return React12.useMemo(
    () => ({
      success: (message, opts) => {
        toast.success(message, opts);
      },
      error: (err, opts) => {
        toast.error(apiError(err).title, opts);
      },
      info: (message, opts) => {
        toast.info(message, opts);
      },
      warning: (message, opts) => {
        toast.warning(message, opts);
      },
      loading: (message, opts) => toast.loading(message, opts),
      promise: (promise, messages) => {
        toast.promise(promise, messages);
      },
      dismiss: (id) => {
        toast.dismiss(id);
      }
    }),
    []
  );
}

export { ALL_BRANCHES, Accordion, AccordionContent, AccordionItem, AccordionTrigger, Alert, AlertDescription, AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertDialogPortal, AlertDialogTitle, AlertDialogTrigger, AlertTitle, AppShell, AuthLayout, Avatar, AvatarFallback, AvatarImage, Badge, BarChart, Breadcrumbs, BulkActionBar, Button, Calendar, Can, Card, CardContent, CardDescription, CardFooter, CardHeader, CardListSkeleton, CardTitle, Checkbox, Collapsible, CollapsibleContent2 as CollapsibleContent, CollapsibleTrigger2 as CollapsibleTrigger, Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandPalette, CommandSeparator, CommandShortcut, ConfirmDialog, ConfirmProvider, ContextMenu, ContextMenuCheckboxItem, ContextMenuContent, ContextMenuGroup, ContextMenuItem, ContextMenuLabel, ContextMenuPortal, ContextMenuRadioGroup, ContextMenuRadioItem, ContextMenuSeparator, ContextMenuShortcut, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger, ContextMenuTrigger, DEFAULT_COUNTRY, DataTable, DataTablePagination, DataTableToolbar, DatePicker, DateRangePicker, DefaultShellLink, DescriptionItem, DescriptionList, DetailSkeleton, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, DonutChart, Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerPortal, DrawerTitle, DrawerTrigger, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger, EmptyState, ErrorState, FileUpload, Form, FormActions, FormField, FormGrid, FormSectionTitle, FormSkeleton, HoverCard, HoverCardContent, HoverCardTrigger, Input, KPICard, Label3 as Label, LoadingState, MobileShell, MoneyDisplay, MoneyInput, NativeSelect, PageHeader, PermissionProvider, PhoneInput, Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger, Progress, RadioGroup3 as RadioGroup, RadioGroupItem, ResourceDetail, ResourceList, ScrollArea, ScrollBar, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue, Separator4 as Separator, Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetOverlay, SheetPortal, SheetTitle, SheetTrigger, SideNav, Skeleton, Slider, StatPageHeader, StatusBadge, Switch, TableSkeleton, Tabs, TabsContent, TabsList, TabsTrigger, Textarea, ThemeProvider, ThemeToggle, ToggleGroup, ToggleGroupItem, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, apiError, badgeVariants, buttonVariants, chartOrientation, cn, colorTokens, colorVar, filterByPermission, formatDate, formatDateTime, formatMoney, formatMoneyValue, formatPhone, isErrorEnvelope, isValidPhone, radiusTokens, seriesColor, shadowTokens, spaceTokens, statusTone, textTokens, toE164, toggleVariants, useConfirm, useDebouncedValue, usePageTitle, usePermission, usePermissionChecker, useSystemThemeSync, useTheme, useToast, zIndexTokens };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map